{
    "LOGIN": {
        "APP-NAME": "{{ appName }} Platform",
        "TITLE": "Melden Sie sich bei der {{ appName }} App an.",
        "ACCOUNT-PLACEHOLDER": "Kontoname",
        "ACCOUNT-REQUIRED": "Kontoname wird benötigt.",
        "ACCOUNT-SHORT": "Der Kontoname muss aus mindestens 2 Zeichen bestehen.",
        "USERNAME-PLACEHOLDER": "Username",
        "USERNAME-REQUIRED": "Username wird benötigt.",
        "USERNAME-SHORT": "Der Username muss aus mindestens 2 Zeichen bestehen.",
        "PASSWORD-PLACEHOLDER": "Passwort",
        "PASSWORD-REQUIRED": "Passwort wird benötigt.",
        "PASSWORD-SHORT": "Das Passwort muss aus mindestens 6 Zeichen bestehen.",
        "REMEMBER-ACCOUNT-NAME": "Automatisches Ausfüllen des Kontonamens deaktivieren",
        "FORGOT-PASSWORD": "PASSWORT VERGESSEN?",
        "LOGIN-BUTTON": "LOGIN",
        "BACK": "ZURÜCK",
        "SSO-BUTTON": "Mit SSO anmelden",
        "BEFORE-TERMS": "Durch Klicken auf Login stimmen Sie unseren ",
        "TERMS": "Nutzungsbedingungen",
        "CONJUNCTION": " und ",
        "PRIVACY": "Datenschutzbestimmungen",
        "AFTER-PRIVACY": " zu.",
        "MORE-OPTIONS": "Weitere Optionen",
        "ALTERNATIVE-CONN-MODE": "Alternativer Verbindungsmodus",
        "ALTERNATIVE-CONN-CAUTION": "Die Auswahl dieser Option hilft, Ihre Verbindung in Regionen zu optimieren, in denen der Internetzugang durch lokale Netzwerkbedingungen beeinträchtigt sein kann.",
        "VERIFICATION-CODE": "Verifizierungscode",
        "VERIFICATION-SENDED": "Wir haben Ihnen eine E-Mail mit einem Verfizierungscode gesendet.",
        "VERIFY-BUTTON": "VERIFIZIEREN",
        "NO-INTERNET-ERROR": "Es ist keine Internetverbindung vorhanden. Bitte überprüfen Sie Ihre Internetverbindung.",
        "USERNAME-PASSWORD-ERROR": "Ihr Username oder Passwort ist ungültig.",
        "INVALID-VERIFICATION-CODE": "Ungültiger 2-Faktor Verifizierungscode. ",
        "ACCOUNT-DISABLED": "Ihre Lizenz ist abgelaufen. Bitte kontaktieren Sie {{ contactMail }}",
        "NO-WORKFLOW-LICENSE": "Sie besitzen keine Workflow-Lizenz. Bitte kontaktieren Sie {{ contactMail }}",
        "UNKNOWN-ERROR": "Beim Anmelden ist ein Fehler aufgetreten.",
        "LINK-ID-MISSING": "Link-ID fehlt",
        "INTERNAL-ERROR": "Unbekannter Fehler",
        "ID-OR-NAME-MISSING": "Link-ID oder Name fehlt",
        "GUEST-PASSWORD-WRONG": "Das Workflow-Passwort ist falsch"
    },
    "USER_PASSWORD": {
        "INVITE_TITLE": "Passwort festlegen",
        "RESET_TITLE": "Passwort zurucksetzen",
        "DESCRIPTION": "Legen Sie ein neues Passwort fur {{ username }} fest.",
        "PASSWORD": "Passwort",
        "CONFIRM_PASSWORD": "Passwort bestatigen",
        "REQUIRED": "Dieses Feld ist erforderlich.",
        "MIN_LENGTH": "Das Passwort muss mindestens 6 Zeichen enthalten.",
        "REQUIREMENTS_TITLE": "Passwortanforderungen:",
        "RULE_MIN_LENGTH": "Mindestens {{ min }} Zeichen",
        "RULE_MAX_LENGTH": "Hochstens {{ max }} Zeichen",
        "RULE_UPPERCASE": "Mindestens ein Grossbuchstabe (A-Z)",
        "RULE_LOWERCASE": "Mindestens ein Kleinbuchstabe (a-z)",
        "RULE_NUMBER": "Mindestens eine Ziffer (0-9)",
        "RULE_SPECIAL": "Mindestens ein Sonderzeichen (z. B. ! @ # $ % & * ?)",
        "RULE_NO_SPACES": "Keine Leerzeichen",
        "RULE_NOT_COMMON": "Kein haufig verwendetes Passwort",
        "MISMATCH": "Die Passworter stimmen nicht uberein.",
        "SUBMIT": "Weiter",
        "SUCCESS": "Passwort wurde gespeichert.",
        "INVALID_PASSWORD": "Das Passwort erfullt die Anforderungen nicht.",
        "LINK_INVALID_TITLE": "Link nicht verfugbar",
        "LINK_INVALID": "Dieser Link ist ungueltig, abgelaufen oder wurde bereits verwendet.",
        "LINK_INVALID_STATE": "Dieser Link passt nicht mehr zum aktuellen Benutzerstatus. Es wird ein neuer Einladungs- oder Reset-Link benoetigt.",
        "LINK_EXPIRED": "Dieser Link ist abgelaufen.",
        "LINK_ALREADY_USED": "Dieser Link wurde bereits verwendet.",
        "LINK_SUPERSEDED": "Es wurde bereits ein neuerer Einladungs- oder Reset-Link erstellt. Bitte verwenden Sie die neueste E-Mail.",
        "BACK_TO_LOGIN": "Zuruck zum Login"
    },
    "MAIN": {
        "CONTENT": {
            "DASHBOARD": {
                "NO-WORKFLOW-FOR-NORMAL-USERS": "Leere Liste",
                "NO-WORKFLOW": {
                    "TITLE": "Workflow",
                    "TEXT": "Möchten Sie wissen, wie Sie Ihre Arbeitsprozesse vereinfachen, Papierkram eliminieren und administrative Aufgaben reduzieren können? Mit VSight Workflow können Sie die Komplexität Ihrer Arbeitsprozesse reduzieren. Erstellen Sie Checklisten, bieten Sie Leitfäden für bestimmte Arbeitsabläufe, fragen Sie Wissen ab, oder erstellen Sie digitale Formulare, die von Usern ausgefüllt werden. Nutzen Sie die großartigen Vorteile der automatischen digitalen Dokumentation aller durchgeführten Schritte. ",
                    "CREATE": "Workflow erstellen"
                },
                "AI-IN-PROGRESS": "KI in Arbeit...",
                "TITLE": "Workflows",
                "CREATE": "Workflow erstellen",
                "GENERATE": "Automatischen Workflow mit KI erstellen",
                "WORKFLOW-TABLE": {
                    "NAME": "Name",
                    "VERSION": "Version",
                    "CREATED-BY": "Erstellt von",
                    "STATUS": {
                        "TITLE": "Status",
                        "PUBLISHED": "Veröffentlicht",
                        "DRAFT": "Entwurf",
                        "INCOMPLETE": "Unvollständig"
                    },
                    "ACTIONS": {
                        "TITLE": "Aktionen",
                        "OPTIONS": {
                            "TITLE": "Optionen",
                            "EDIT": "Entwurf bearbeiten",
                            "USERS": "User",
                            "SHARING": "Freigabe",
                            "PUBLISH": "Entwurf veröffentlichen",
                            "PUBLISH-VIEW": "Veröffentlichte Version anzeigen",
                            "DUPLICATE": "Workflow duplizieren",
                            "DELETE": "Workflow löschen",
                            "MOVE-TO-FOLDER": "In Ordner verschieben"
                        },
                        "PREFILLED-OPTIONS": {
                            "EDIT": "Bearbeiten",
                            "SHOW-QR": "QR anzeigen",
                            "DUPLICATE": "Duplizieren",
                            "DELETE": "Löschen"
                        },
                        "SUBMITTED-OPTIONS": {
                            "SHOW-REPORT": "Zeige Bericht",
                            "CHANGE-PREFILLED": "Wechseln Sie zu vorgefüllt"
                        }
                    },
                    "START": "START",
                    "LAST-EDITED": "Zuletzt bearbeitet am",
                    "PUBLISHED-AT": "Veröffentlicht am",
                    "LANGUAGES": "Sprachen",
                    "CONTENT-LANGUAGE": "Inhaltssprache",
                    "FILTER": {
                        "FILTER-BY": "Filtern nach",
                        "SELECT-LABEL": "Label auswählen",
                        "SELECTED-LABELS": "Ausgewählte Label",
                        "SELECT-STATUS": "Status auswählen",
                        "SELECTED-STATUSES": "Ausgewählte Stati",
                        "CLEAR-ALL": "Alle löschen",
                        "EWERS-SEARCH-PLACEHOLDER": "Suche mit Auftrags-Nr. / Serien-Nr.",
                        "EWERS-ID-LABEL": "Auftrags-Nr. / Serien-Nr."
                    },
                    "MANAGE-WORKFLOWS": "Workflows verwalten"
                },
                "TABS": {
                    "MY-WORKFLOWS": "Meine Workflows",
                    "SUBMITTED-WORKFLOWS": "Eingereichte Workflows",
                    "SHARED-WORKFLOWS": "Geteilte Workflows",
                    "SHARED-WORKFLOW": "Geteilter Workflow"
                },
                "VIEW-MODES": {
                    "LIST": "Liste",
                    "FOLDER": "Ordner"
                },
                "FOLDER": {
                    "MOVE-TO-FOLDER": "In den Ordner verschieben",
                    "SELECTED": "ausgewählt",
                    "CREATE-FOLDER": "NEUEN ORDNER ERSTELLEN",
                    "NOT-FOLDERED": "Nicht geordnet",
                    "DELETE-FOLDER": "Lösche Ordner",
                    "NO-WORKFLOW-FOUND": "Keine Workflows gefunden.",
                    "EDIT-FOLDER": "Ordner bearbeiten",
                    "MOVE-TO": "Ziehen nach",
                    "FOLDER-NAME": "Ordnernamen",
                    "CREATE": "Erstellen",
                    "FOLDERS": "Ordner",
                    "FOLDER-NAME-UNIQUE-ERROR": "Der Ordnername muss eindeutig sein",
                    "DELETE-FOLDER-WARNING-TEXT": "Sind Sie sicher, dass Sie den Ordner löschen möchten?",
                    "DELETE-FOLDER-INFO-TEXT": "Durch das Löschen dieses Ordners werden die darin enthaltenen Workflows nicht gelöscht. Sie werden nach 'Nicht im Ordner' verschoben."
                },
                "SEARCH": {
                    "TITLE": "Erweiterte Suche",
                    "PLACEHOLDER": "Suchanfrage eingeben...",
                    "BUTTON": "Suchen",
                    "CANCEL": "Abbrechen",
                    "CLEAR": "Suche löschen",
                    "RESULTS": "Suchergebnisse",
                    "NO_RESULTS": "Keine Workflows für Ihre Suchanfrage gefunden.",
                    "ERROR": "Suche fehlgeschlagen. Bitte versuchen Sie es erneut.",
                    "APPLIED": "Suche angewendet"
                },
                "TEXT-MESSAGE": "Ihre Änderungen werden entfernt. Möchten Sie diesen Workflow verwerfen?",
                "TEXT-MESSAGE-PUBLISH-VIEW": "Sie wechseln in den Bearbeitungsmodus. Dort können Sie Änderungen am aktuellen Entwurf vornehmen.",
                "TEXT-MESSAGE-UNSAVED-CHANGES": "Es liegen nicht gespeicherte Änderungen vor. Diese werden hiermit gespeichert und veröffentlicht.",
                "TEXT-MESSAGE-CLOSE-WORKFLOW": "Möchten Sie diesen Workflow wirklich schließen? Ihre Änderungen werden verworfen.",
                "TEXT-MESSAGE-CONDITIONAL-WORKFLOW": "Dieser Workflow enthält Bedingungen. Unsere Webversion unterstützt aktuell noch keine Bedingungen.",
                "CANCEL": "ABBRECHEN",
                "CLOSE": "SCHLIESSEN",
                "EXPORT-WORKFLOWS": "WORKFLOWS EXPORTIEREN",
                "SAVE-AS-DRAFT": "Als einen Entwurf sichern",
                "CONTINUE": "Fortfahren",
                "UPDATE": "Aktualisieren",
                "CONTINUE-UPPERCASE": "FORTFAHREN",
                "START-OVER": "NEU STARTEN",
                "WORKFLOW-STARTED": "Sie haben diesen Workflow bereits gestartet. Möchten Sie fortfahren oder ein neues beginnen?",
                "NEW-VERSION": "Dieser Workflow kann nicht geöffnet werden. Sie müssen eine neue Version von Workflow veröffentlichen",
                "ANOTHER-COPY": "Eine Kopie dieses Workflows wird als Version 1 im Entwurfsstatus erstellt und mit dem Zusatz \"(Copy)\" benannt. Alle Schritte, Felder und Dateien werden ebenfalls kopiert.",
                "DUPLICATE-SUCCESSFUL": "Workflow wurde erfolgreich kopiert.",
                "DUPLICATE-NESTED-SKIPPED": "Verknüpfungen zu verschachtelten Workflows wurden nicht kopiert.",
                "DUPLICATE-FILES-FAILED": "{{count}} Datei(en) konnten nicht kopiert werden. Die Kopie verweist weiterhin auf die Originaldateien.",
                "DUPLICATE-PARTIAL": "Die Kopie wurde erstellt, das Kopieren der Dateien wurde jedoch nicht abgeschlossen. Öffnen Sie die Kopie und prüfen Sie die Medien.",
                "DUPLICATE-ERROR": "Dieser Workflow kann nicht kopiert werden.",
                "DELETE-SUCCESSFUL": "Der Löschvorgang war erfolgreich",
                "DELETE-ERROR": "Fehler löschen",
                "WORKFLOW-NOT-FOUND": "Workflow nicht gefunden",
                "CREATION-LIMIT": "Das Limit für die Workflow-Erstellung wurde erreicht",
                "PUBLISH-SUCCESSFUL": "Die Veröffentlichung war erfolgreich",
                "PUBLISH-ERROR": "Veröffentlichungsfehler",
                "EXPORT-CANCELED": "Export abgebrochen",
                "EXPORT-FOLDER": "Exportordner existiert",
                "EXPORT-SUCCESSFUL": "Der Export ist erfolgreich",
                "YES": "JA",
                "DELETE-REPORT-TITLE": "Bericht löschen",
                "DELETE-REPORT-TEXT": "Sind Sie sicher, dass Sie diesen Bericht löschen möchten?",
                "SAVE-PREFILLED-TITLE": "Änderungen speichern",
                "SAVE-PREFILLED-TEXT": "Ihre Änderungen werden gespeichert. Sind Sie sicher, dass Sie fortfahren möchten?",
                "TEXT-MESSAGE-PREFILLED-EDIT": "Beim Bearbeiten müssen ein neuer QR-Code und ein neuer Link generiert werden. Der vorherige QR-Code und der vorherige Link werden ungültig",
                "TEXT-MESSAGE-PREFILLED-EDIT-TITLE": "Vorgefüllten Workflow bearbeiten",
                "CONNECTED-WORKFLOW-WARNING-TEXT": "Dieser Workflow kann nicht gelöscht werden, da er mit einem anderen Workflow verbunden ist. Sie müssen es zunächst aus dem verbundenen Workflow entfernen.",
                "SUBMITTED-REPORT-TO-PREFILLED-TEXT": "Sind Sie sicher, dass Sie diesen Bericht als vorausgefüllten Bericht ändern möchten?",
                "SUBMITTED-REPORT-TO-PREFILLED-TITLE": "Berichtsstatus ändern",
                "NESTED-WORKFLOWS-CONNECTION-ENABLE-WARNING": "In dem von Ihnen hinzugefügten Workflow besteht eine Verbindung. Daher wird die Verbindung in Ihrem aktuellen Workflow aktiviert. Überprüfen Sie nach dem Speichern Ihres Workflows die Seite Verbindungen."
            },
            "REMOTE": {
                "IMAGE-COLLABORATION": {
                    "UNDO": "Rückgängig",
                    "REDO": "Wiederholen",
                    "ANNOTATE": "Annotieren",
                    "REVERT": "Zurücksetzen",
                    "ZOOM-IN": "Hineinzoomen",
                    "ZOOM-OUT": "Herauszoomen",
                    "UP": "Nach oben",
                    "DOWN": "Nach unten",
                    "LEFT": "Links",
                    "RIGHT": "Rechts"
                }
            },
            "REPORT": {
                "NAME": "Name",
                "DESCRIPTION": "Beschreibung",
                "STEPS-COMPLETED": "Durchzuführende Schritte",
                "START": "Gestartet am",
                "END": "Beendet am",
                "DURATION": "Dauer",
                "EXPORT": "CSV-Datei exportieren",
                "SUBMITTED-BY":"Eingereicht von",
                "PREFILLED-BY": "Vorausgefüllt von",
                "PREFILLED-AT": "Vorausgefüllt am",
                "QR-SCANNED-AT": "QR gescanned am",
                "SAVE-PDF": "Als PDF speichern",
                "STEP-LIST": {
                    "NAME": "Schrittbezeichnung",
                    "CONTENT": "Inhalt",
                    "DURATION": "Dauer",
                    "NO-CONTENT": "N/A",
                    "DETECTED": "Erkannt",
                    "NOT-DETECTED": "Nicht erkannt",
                    "MATCHED": "Übereinstimmung",
                    "NOT-MATCHED": "keine Übereinstimmung",
                    "ENTERED-VALUE": "Eingegebener Wert",
                    "SCANNED-VALUE": "Gescannter Wert"
                },
                "FILES": "Dateien",
                "OPTIONS": "Optionen",
                "APPROVAL": {
                    "TITLE": "Genehmigung",
                    "DESCRIPTION-TEXT": "Um diesen Bericht zu genehmigen, unterschreiben Sie bitte, indem Sie auf SIGNATUR klicken.",
                    "SIGN": "SIGNATUR",
                    "RESEND": "Genehmigungsanfrage erneut senden",
                    "NOT-SIGNED": "NICHT UNTERSCHRIEBEN",
                    "DELETE-APPROVAL": "Sind Sie sicher, dass Sie löschen möchten?",
                    "DELETE": "Löschen"
                },
                "SELECT-LANGUAGE": "Sprache auswählen",
                "MISSING-PARAMETERS": "Es fehlen Parameter",
                "INVALID-TOKEN": "Ungültiges Token",
                "REPORT-NOT-FOUND": "Bericht wurde nicht gefunden",
                "SUCCESSFULLY-SENDED": "Erfolgreich gesendet",
                "REMOTE-CALL": {
                    "TITLE": "Remote Anrufe",
                    "STATUS": "Status",
                    "STEP": "Schritt",
                    "USERS": "User",
                    "GUEST": "Gast",
                    "CALL-FAILED": "Anruf wurde nicht gestartet",
                    "CREATED-AT": "Hergestellt in"
                },
                "LOADING": "Wird geladen..."
            },
            "REPORT-LIST": {
                "NO-REPORT": {
                    "TITLE": "Workflow Report",
                    "TEXT": "Es liegen keine Reports vor.",
                    "NO-REPORT-FOUND": "Es wurde kein Bericht gefunden, der mit der angegebenen Link-ID verknüpft ist"
                },
                "TITLE": "Reports",
                "PLACEHOLDER": "Suche mit Name",
                "LIST": {
                    "WORKFLOW": "Workflow",
                    "VERSION": "Version",
                    "SUBMITTED-BY": "Eingereicht von",
                    "SUBMITTED-TITLE": "Eingereicht am",
                    "SUBMITTED": "Eingereicht",
                    "APPROVAL": "Genehmigung",
                    "APPROVED": "Genehmigt",
                    "PENDING": "Ausstehend",
                    "VIEW": "Einsehen",
                    "PREFILLED": "Vorausgefüllt"
                },
                "LAST-SAVED": "Zuletzt gespeichert am",
                "PERMISSION-ERROR": "Sie sind nicht berechtigt, die Reports einzusehen.",
                "ERROR": "FEHLER",
                "IMPORT-CANCELED": "Import abgebrochen",
                "REPORT-FORMAT-WRONG": "Das Berichtsformat ist falsch",
                "IMPORT-SUCCESSFUL": "Der Import ist erfolgreich",
                "FILTER-ID": "Suche mit Tag-ID",
                "ID-TAG": "Tag-ID",
                "IMPORT_REPORTS": "BERICHTE IMPORTIEREN",
                "WORKFLOW_REPORTS": "Workflow-Berichte",
                "REMOTE_SESSIONS": "Remote-Sessions",
                "OPTIONS": "Optionen"
            },
            "USER-DETAIL": {
                "CREATE_TITLE": "User erstellen",
                "INVITE_TITLE": "Benutzer einladen",
                "EDIT_TITLE": "User bearbeiten",
                "EDIT_DETAILS": "Userdetails bearbeiten",
                "NAME": "Name",
                "NAME_REQUIRED": "Name wird benötigt.",
                "NAME_PATTERN": "Der Name darf nur Buchstaben, Ziffern, Unterstriche ( _ ) und Bindestriche ( - ) enthalten.",
                "USERNAME": "Username",
                "USERNAME_REQUIRED": "Username wird benötigt.",
                "USERNAME_PATTERN": "Der Username darf nur Buchstaben, Zahlen, Unterstriche ( _ ) und Bindestriche ( - ) enthalten.",
                "USERNAME_EXISTS": "Dieser Username existiert bereits.",
                "EMAIL": "Email",
                "EMAIL_REQUIRED": "Email wird benötigt.",
                "INVALID_EMAIL": "Ungültiges Email-Format",
                "SAVE_CHANGES": "ÄNDERUNGEN SPEICHERN",
                "DELETE_USER": "USER LÖSCHEN",
                "CHANGE_PASSWORD": "Passwort ändern",
                "CREATE_PASSWORD": "Passwort erstellen",
                "NEW_PASSWORD": "Neues Passwort",
                "CONFIRM_NEW_PASSWORD": "Neues Passwort bestätigen",
                "SUBMIT_NEW_PASSWORD": "PASSWORT ÄNDERN",
                "PASSWORD_REQUIRED": "Passwort wird benötigt.",
                "PASSWORD_REQUIREMENTS": "Das Passwort erfüllt die folgenden Anforderungen nicht.",
                "CONFIRM_PASSWORD": "Passwort bestätigen",
                "CONFIRM_REQUIRED": "Passwortbestätigung wird benötigt.",
                "PASSWORD_MATCH": "Die Passwörter stimmen nicht überein.",
                "PASSWORD_MUST": "Das Passwort muss:",
                "MIN_LENGTH": "aus mindestens {{ minPasswordLength }} Zeichen bestehen",
                "UPPERCASE": " mindestens einen Großbuchstaben (A-Z) enthalten",
                "LOWERCASE": " mindestens einen Kleinbuchstaben (a-z) enthalten",
                "NUMBER": "mindestens eine Zahl (0-9) enthalten ",
                "SPECIAL": "mindestens ein Sonderzeichen (-*/?#&()) enthalten ",
                "SUBMIT": "USER ERSTELLEN",
                "QR_CODE": "QR-Code",
                "AUTHENTICATE": "Sie können Datenbrillen und Mobiltelefone mit Ihrem QR-Code authentifizieren.",
                "GENERATE_QR_CODE": "QR GENERIEREN",
                "REGENERATE_QR_CODE": "Code neu generieren",
                "DOWNLOAD": "DOWNLOAD",
                "DELETE": "LÖSCHEN",
                "LIMIT-WARNING": "Der User wird erstellt, ist aber kein lizenzierter Workflow-User, da Sie Ihr Limit bereits erreicht haben.",
                "DELETE-USER-OR-NOT": "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
                "DELETE-QR-OR-NOT": "Sind Sie sicher, dass Sie diesen QR-Code löschen möchten?",
                "CREATED-SUCCESSFULLY": "Der Benutzer wurde erfolgreich erstellt. Ihr Workflow-Benutzerlimit ist jedoch ausgeschopft. Dieser Benutzer ist kein Workflow-Benutzer",
                "INVITE-SENT": "Benutzer erstellt und Einladung versendet.",
                "INVITE-RESENT": "Einladung wurde erneut versendet.",
                "SEND_INVITE": "Einladung senden",
                "RESET-SENT": "E-Mail zum Zurucksetzen des Passworts wurde versendet.",
                "RESEND_INVITE": "Einladung Erneut Senden",
                "RESET_PASSWORD_EMAIL": "RESET-E-MAIL Senden",
                "RESET_PASSWORD_EMAIL_REQUIRED": "Die E-Mail-Adresse des Benutzers muss zuerst festgelegt werden.",
                "ROLE": "Rolle",
                "MORE_SETTINGS": "Weitere Einstellungen",
                "EDITOR-ACCESS": "Editorzugriff",
                "EDITOR-ACCESS-TEXT": "Der Benutzer erhält Zugriff auf den Editor, damit er Workflows erstellen und bearbeiten kann.",
                    "REMOTE-ASSISTANCE": "Remote Assistance Einstellungen",
                "WEAK-PASSWORD-WARNING": "Erstellen Sie keine schwachen Passwörter wie '123456'"
            },
            "USER-LIST": {
                "TITLE": "User",
                "CREATE": "USER ERSTELLEN",
                "CREATE-TEAM": "TEAM ERSTELLEN",
                "CREATE-WORK-GROUP": "Arbeitsgruppe erstellen",
                "WORK-GROUPS": "Arbeitsgruppen",
                "SIMPLIFY": "Möchten Sie wissen, wie Sie Ihre Arbeitsprozesse vereinfachen, Papierkram eliminieren und administrative Aufgaben reduzieren können? Mit VSight Workflow können Sie die Komplexität Ihrer Arbeitsprozesse reduzieren. Erstellen Sie Checklisten, bieten Sie Leitfäden für bestimmte Arbeitsabläufe, fragen Sie Wissen ab, oder erstellen Sie digitale Formulare, die von Usern ausgefüllt werden. Nutzen Sie die großartigen Vorteile der automatischen digitalen Dokumentation aller durchgeführten Schritte. ",
                "LICENSED": "Lizenzierte Workflow-User:",
                "LICENSED-EXPERT": "Lizenzierte Experten-User:",
                "SEARCH": "Suchen",
                "UNLIMITED": "Unbegrenzt",
                "USER-ACTIVATED": "User aktiviert",
                "LIMIT-EXCEEDED": "! Limit überschritten",
                "LIST": {
                    "WORKFLOW-USER": "Workflow-User",
                    "NAME": "Name",
                    "USERNAME": "Username",
                    "MEMBERS": "Mitglieder"
                },
                "SAMPLE": {
                    "TEAM-NAME": "Marketing",
                    "MEMBER-COUNT": "10 Mitglieder"
                },
                "ACTIONS": {
                    "OPTIONS": "Optionen",
                    "EDIT": "Bearbeiten",
                    "DELETE": "Löschen"
                },
                "LICENCE-LIMIT": "Ihr Konto hat die maximale Anzahl an Workflow-Übermittlungen erreicht. Bitte aktualisieren Sie Ihre Lizenz, um die neuesten Workflow-Einreichungen zu sehen.",
                "DEACTIVATE": {
                    "DEACTIVATED": "User deaktiviert",
                    "SAVE": "Speichern",
                    "CANCEL": "Abbrechen"
                },
                "CHANGES-WARNING": "Es liegen nicht gespeicherte Änderungen vor. Möchten Sie wirklich schließen?",
                "DELETE-OR-NOT": "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
                "SAVE-SUCCESSFUL": "Speichern erfolgreich",
                "LIMIT-EXCEED":"Grenzwert überschritten.",
                "ERROR": "Fehler",
                "INVITE_PENDING": "Ausstehend",
                "USERS-AND-TEAMS": "Benutzer und Teams",
                "TEAMS": "Teams",
                "TEAM": "Team"
            },
            "WORKFLOW": {
                "REQUIRED": "Pflichtfeld",
                "SIDEBAR": {
                    "DETAILS": "Details",
                    "EDITOR": "Editor",
                    "CONNECTIONS": "Bedingungen"
                },
                "WORKFLOW-DETAIL": {
                    "TITLE": "Details",
                    "NAME": {
                        "TITLE": "Name",
                        "REQUIRED": "erforderlich",
                        "NO-NAME": "Dieses Feld ist erforderlich"
                    },
                    "DESCRIPTION": "Beschreibung",
                    "DURATION": "Geschätzte Dauer",
                    "LABEL": {
                        "TITLE": "Labels",
                        "CREATE": "Neu erstellen",
                        "NO-ITEMS-FOUND": "keine Einträge gefunden"
                    },
                    "SHOW-CONTENT-PAGE": "Inhaltsseite anzeigen",
                    "UPLOAD-FILE": "Datei hochladen",
                    "PREVIEW-TEXT": "Um den Workflow zu bearbeiten, gehen Sie bitte auf die Editor Seite.",
                    "UPLOAD-FILE-INFO": "Sie können zusätzliche Dateien hochladen. Derzeit werden nur PDF-Dateien unterstützt.",
                    "CONNECTION-WARNING": "Die Inhaltsseite kann nicht angezeigt werden, da Bedingungen aktiviert sind.",
                    "DELETE-FILE": "Möchten Sie diese Datei wirklich löschen?",
                    "REMOTE-CALL-EXPERTS": "Fernanruf mit Experten"
                },
                "WORKFLOW-STEPS": {
                    "STEP-LIST": {
                        "INFORM": "Einen neuen Schritt erstellen Sie über die Schaltfläche unten links.",
                        "STEP": {
                            "NO-NAME": "Schrittname wird benötigt.",
                            "OPTIONS": {
                                "RENAME": "Umbenennen",
                                "DUPLICATE": "Duplizieren",
                                "DELETE": "Löschen",
                                "MOVE": "Verschieben",
                                "CLONE": "Klonen",
                                "CLONE-STEP": "Schritt klonen",
                                "MOVE-STEP": "Schritt verschieben"
                            },
                            "CREATE": "Neuer Schritt",
                            "ADD-STEP": "Schritt hinzufügen"
                        },
                        "MANAGE-STEPS": {
                            "TITLE": "Schritte bearbeiten",
                            "DELETE": "Löschen",
                            "DUPLICATE": "Duplizieren",
                            "CLONE": "Klonen",
                            "MOVE": "Verschieben",
                            "SELECT-ALL": "Alle auswählen",
                            "DESELECT-ALL": "Auswahl aufheben",
                            "CONNECTION-VIEW-DISABLED": "Gesperrt durch aktivierte Bedingungen"
                        },
                        "TEXT-MESSAGE": "Ihre Änderungen werden verworfen. Möchten Sie die hinzugefügten Schritte wirklich löschen?",
                        "CLONE-TEXT-MESSAGE": "Dieser Schritt wird in den ausgewählten Workflow kopiert.",
                        "MOVE-TEXT-MESSAGE": "Dieser Schritt wird in den ausgewählten Workflow verschoben und aus diesem Workflow gelöscht.",
                        "SELECT": "Auswählen",
                        "CREATE-SECTION": "Abschnitt erstellen",
                        "SECTION-TEXT-MESSAGE": "Dieser Workflow enthält keine Abschnitte. Wenn Sie einen Abschnitt erstellen, werden zuvor erstellte Schritte hinzugefügt. Möchten Sie fortfahren?",
                        "SECTION-DELETE-TEXT-MESSAGE": "Dieser Abschnitt und Schritte unter dem Abschnitt werden entfernt. Wenn es Schritte gibt, die Sie nicht löschen möchten, können Sie sie vor dem Löschen verschieben.",
                        "INDEPENDENT": "Schritte können nicht unabhängig vom Abschnitt sein",
                        "DELETE-STEP": "Ausgewählte Schritte werden gelöscht. Sind Sie sicher, dass Sie die folgenden Schritte löschen möchten?",
                        "INITIAL-STEP-WARNING-MESSAGE": "Der ausgewählte Schritt ist der erste Schritt des Workflows. Vor dem Löschen müssen Sie den ersten Schritt ändern.",
                        "CONNECTED-STEPS-WARNING-MESSAGE": "Mit diesen Schritten sind verbundene Schritte verbunden. Wenn Sie diesen Schritt löschen, gehen Ihre Verbindungen verloren. Bitte überprüfen Sie Ihre Verbindungen auf der Seite 'Bedingungen'."
                    },
                    "STEP-PREVIEW": {
                        "NO-STEP": "Nicht ausgewählt"
                    },
                    "WIDGET-PROPERTIES": {
                        "EMPTY": "Klicken Sie hier, um Inhalte hinzuzufügen.",
                        "INFORM": "In der Schrittvorschau können Sie sehen, wie Ihre Inhalte für den User dargestellt werden.",
                        "BACK": "Zurück",
                        "POSITION": {
                            "TITLE": "Position",
                            "HORIZONTAL": "Horizontale Position",
                            "VERTICAL": "Vertikale Position"
                        },
                        "LABEL": {
                            "TITLE": "Titel",
                            "REQUIRED": "erforderlich",
                            "NO-LABEL": "Label wird benötigt."
                        },
                        "PLACEHOLDER": "Platzhalter",
                        "OPTIONS": {
                            "TITLE": "Optionen",
                            "NO-LABEL": "Label wird benötigt.",
                            "MUST-UNIQUE": "Optionen dürfen sich nicht wiederholen.",
                            "DELETE-LAST": " - Das letzte Element kann nicht gelöscht werden.",
                            "ADD": "Option hinzufügen",
                            "MAX-ADDED": "Das Hinzufügen vieler Elemente erfordert ggf. das Scrollen auf Datenbrillen."
                        },
                        "NUMBER-FIELDS": {
                            "MIN": "Min.",
                            "MAX": "Max.",
                            "UNIT": "Einheit",
                            "PRECISION": "Nachkommastellen"
                        },
                        "PPE-FIELDS": {
                            "TITLE": "Wählen Sie, welche der folgenden Gegenstände erkannt werden sollen: ",
                            "FACE": "Gesichtsmaske",
                            "HEAD": "Schutzhelm",
                            "HAND": "Schutzhandschuhe",
                            "NO-RECOGNITION": "Wählen Sie mindestens einen Schutzausrüstungsgegenstand aus."
                        },
                        "TIME-PICKER": "Datum inkl. Uhrzeit",
                        "QR-FIELD": "QR-Code-Wert",
                        "QR-ACTIVATION": "Aktivieren Sie die QR-Code-Validierung",
                        "QR-FIELD-VALIDATION-TEXT": "QR-Feld ist erforderlich.",
                        "QR-ACTIVATION-INFO-TEXT": "Wenn die QR-Code-Validierung aktiviert ist, wird der von Ihnen bereitgestellte QR-Code-Wert (QR-Link) mit dem vom User gescannten QR-Code verglichen, um festzustellen, ob sie übereinstimmen.",
                        "REQUIRED": {
                            "TEXT": "Machen Sie dieses Feld zu einem Pflichtfeld.",
                            "INFORM": "Aktivieren Sie diese Schaltfläche, wenn Sie sicherstellen möchten, dass dieser Schritt vom User nicht übersprungen werden kann."
                        },
                        "IMAGE": {
                            "TITLE": "Bild hochladen",
                            "REQUIRED": "erforderlich",
                            "UPLOAD": {
                                "DRAG-DROP": "Drag & Drop",
                                "INFORM": "Ziehen Sie Ihre Dateien hierhin, oder klicken Sie auf die Schaltfläche zum Hochladen",
                                "CLICK": {
                                    "UPLOAD": "Bild hochladen",
                                    "CHANGE": "Bild ändern",
                                    "EDIT": "Bild bearbeiten"
                                }
                            },
                            "NO-IMAGE": "Bild wird benötigt."
                        },
                        "GALLERY": {
                            "TITLE": "Bilder hochladen",
                            "REQUIRED": "erforderlich",
                            "NO-IMAGE": "Bild wird benötigt.",
                            "DELETE-IMAGE-TEXT-MESSAGE": "Möchten Sie dieses Bild wirklich löschen?",
                            "VALIDATION-TEXT": "Sie können maximal 50 Bilder hochladen.",
                            "DELETE-IMAGE": "Lösche Bild"
                        },
                        "VIDEO": {
                            "TITLE": "Video hochladen",
                            "REQUIRED": "erforderlich",
                            "UPLOAD": {
                                "DRAG-DROP": "Drag & Drop",
                                "INFORM": "Ziehen Sie Ihre Dateien hierhin, oder klicken Sie hier, um diese hochzuladen.",
                                "CLICK": {
                                    "UPLOAD": "Video hochladen",
                                    "CHANGE": "Video ändern"
                                }
                            },
                            "NO-IMAGE": "Video wird benötigt."
                        },
                        "PDF": {
                            "TITLE": "PDF hochladen",
                            "REQUIRED": "erforderlich",
                            "UPLOAD": {
                                "DRAG-DROP": "Drag & Drop",
                                "INFORM": "Ziehen Sie Ihre Dateien hierhin, oder klicken Sie hier, um diese hochzuladen.",
                                "CLICK": {
                                    "UPLOAD": "PDF hochladen",
                                    "CHANGE": "PDF ändern"
                                }
                            },
                            "NO-IMAGE": "PDF wird benötigt."
                        },
                        "TABLE": {
                            "CREATE-TABLE": "Tabelle erstellen",
                            "COLUMN": "Spalte",
                            "ROW": "Zeile",
                            "CREATE": "Erstellen",
                            "ADD-ROW": "Zeile hinzufügen",
                            "DELETE-ROW": "Zeile löschen",
                            "ADD-COLUMN": "Spalte hinzufügen",
                            "DELETE-COLUMN": "Spalte löschen",
                            "SELECT-CELL-TEXT": "Um die Tabelle zu füllen, wählen Sie bitte eine Zelle aus",
                            "SELECT-CONTENT-TYPE-TEXT": "Wählen Sie den Inhaltstyp aus",
                            "SELECTED": "Ausgewählte Zelle : ",
                            "COLUMN-VALIDATION-TEXT": "Die Spalten sollten mindestens 1 sein.",
                            "ROW-VALIDATION-TEXT": "Zeilen sollten mindestens 1 sein.",
                            "CLEAR": "Inhalt Löschen",
                            "HEADER-CELL-INFO": "Kopfzellen können nur Beschriftungen für Spaltennamen enthalten",
                            "Label": "Textanweisung",
                            "Input": "Texteingabe",
                            "Number": "Zahleneingabe",
                            "Datepicker": "Datumsauswahl",
                            "Checkbox": "Checkboxen",
                            "Radio": "Radiobuttons"
                        },
                        "TEXT-MESSAGE": "Möchten Sie dieses Widget wirklich ersetzen?",
                        "DELETE-TEXT-MESSAGE": "Möchten Sie dieses Widget wirklich löschen?",
                        "TITLE-DELETE": "Widget löschen",
                        "TITLE-CHANGE": "Widget ersetzen",
                        "REPLACE": "Ersetzen",
                        "DELETE-ROW-TEXT-MESSAGE": "Sind Sie sicher, dass Sie die Zeile löschen möchten?",
                        "DELETE-COLUMN-TEXT-MESSAGE": "Sind Sie sicher, dass Sie die Spalte löschen möchten?",
                        "TITLE-DELETE-ROW": "Zeile löschen",
                        "TITLE-DELETE-COLUMN": "Spalte löschen",
                        "CONNECTION-WARNING-TEXT-MESSAGE": "Sie können dieses Widget nicht ändern, da es an eine Bedingung gekoppelt ist.",
                        "CONNECTION-WARNING-HEADER": "Warnung",
                        "WIDGET-TITLES": {
                            "LABEL": "Textanweisung",
                            "TEXT-INPUT": "Texteingabe",
                            "NUMBER-INPUT": "Zahleneingabe",
                            "DATE-PICKER": "Datumsauswahl",
                            "CHECKBOX": "Checkboxen",
                            "RADIO-BUTTON": "Radiobuttons",
                            "IMAGE": "Bildanweisung",
                            "VIDEO": "Videoanweisung",
                            "PDF": "PDF-Anweisung",
                            "DETECT-QR": "QR-Code Scanner",
                            "CAPTURE-IMAGE": "Bild aufnehmen",
                            "CAPTURE-VIDEO": "Video aufnehmen",
                            "PPE": "PSA erkennen",
                            "VOICE-RECORD": "Sprache aufnehmen",
                            "VOICE": "Sprachanweisung",
                            "VSIGHT-REMOTE": "VSight Remote",
                            "AR-INSTRUCTION": "AR-Anweisung",
                            "HTML": "Rich-Text",
                            "GALLERY": "Galerie",
                            "TABLE": "Tabelle",
                            "FORM": "Formular",
                            "WORKFLOW": "Workflow",
                            "ID": "Tag-ID",
                            "SIGNATURE": "Signatur"
                        },
                        "WIDGET-DESCRIPTION": {
                            "INSTRUCTION": "Information",
                            "FEEDBACK": "Feedback",
                            "VISUAL-SUPPORT": "Live Unterstützung",
                            "AUGMENTED-REALITY": "Augmented Reality",
                            "VISUAL-AI": "Visuelle KI",
                            "COMING-SOON": "in Kürze verfügbar",
                            "FULLSCREEN": "nur auf ganzen Seiten platzierbar"
                        },
                        "LIMIT-EXCEED": "Grenzwert überschritten. Die maximale Grenze liegt bei 50."
                    },
                    "STEP-FILES": {
                        "TITLE": "Step-Dateien",
                        "VIEW-STEP-FILES": "Schrittdateien anzeigen"
                    }
                },
                "TITLE": "Workflow",
                "APPROVE": "Genehmigen",
                "CANCEL": "Abbrechen",
                "SAVE": "Entwurf speichern",
                "PUBLISH": "Veröffentlichen",
                "SAVE-PUBLISH": "Speichern & Veröffentlichen",
                "EDIT-WORKFLOW": "WORKFLOW BEARBEITEN",
                "EDIT-WORKFLOW-TITLE": "Workflow bearbeiten",
                "EDIT-MODE-TEXT-MESSAGE": "Sie befinden sich im Vorschaumodus. Klicken Sie auf die Schaltfläche „WORKFLOW BEARBEITEN“, um Änderungen vorzunehmen.",
                "STEP-PREVIEW": "Vorschau",
                "WIDGET-PROPERTIES": "Klicken Sie in ein Fenster der Vorschau, um dort ein Widget hinzuzufügen.",
                "CONNECTIONS-PAGE": "Bedingungen",
                "CHANGE-STEP-LAYOUT": "Seiten-Layout ändern",
                "ERROR-MESSAGE": {
                    "MESSAGE": "Sie können nur in das Layout \"ganze Seite\" wechseln, wenn mindestens eine Hälfte der Vorschau leer ist.",
                    "NOT-SUPPORT": "Dieses Widget wird im ausgewählten Layout nicht unterstützt.",
                    "CONFIRM": "Schließen"
                },
                "TEXT-MESSAGE": {
                    "MESSAGE": "Möchten Sie den Editor wirklich schließen? Nicht gespeicherte Änderungen gehen dadurch verloren.",
                    "CONFIRM": "Schließen",
                    "OK": "OK",
                    "SWITCH-MODE-MESSAGE": "Sind Sie sicher, dass Sie den Modus wechseln möchten?"
                },
                "PREVIEW": {
                    "DETECT-QR": "QR-Code/Barcode erkennen",
                    "DETECT-PPE": "PSA Erkennung über ein Kamerabild",
                    "PICK_IMAGE": "Bild aus der Galerie",
                    "PICK-VIDEO": "Video aus der Galerie",
                    "CAPTURE-VIDEO": "Video aufnehmen",
                    "CAPTURE-IMAGE": "Bild aufnehmen",
                    "DETECT-PPE-FROM-FINDER": "Wählen Sie ein PSA-Bild aus",
                    "DETECT-QR-WITH-UPLOAD": "Wählen Sie ein QR-Bild aus",
                    "DETECT-QR-WITH-CAMERA": "QR-Code/Barcode von der Kamera erkennen",
                    "SIGN-HERE": "Hier unterschreiben"
                },
                "WORKFLOW-CONNECTIONS": {
                    "CONDITIONS": "Bedingungen",
                    "ADD-CONDITION": "Bedingung hinzufügen",
                    "INFORM-TEXT": "Wählen Sie einen Schritt aus, um eine Bedingung hinzuzufügen.",
                    "FROM": "Von",
                    "TO": "Bis",
                    "DELETE-CONNECTION": "Verbindung löschen",
                    "WHEN": "Wenn",
                    "REQUIRED-FIELD": "Pflichtfeld",
                    "ADD-LOGICAL-CONDITION": "Bedingung hinzufügen",
                    "DELETE-CONDITION": "Bedingung löschen",
                    "CONDITION": "Bedingung",
                    "GO-TO": "Gehe zu",
                    "ELSE-CONDITION-TEXT": "Wenn keine Bedingungen zutreffen, gehe zu",
                    "NOT-SELECTED": "Nicht ausgewählt",
                    "TURN-ON-CONNECTIONS": "Aktivieren Sie Bedingungen",
                    "TURN-ON-CONNECTIONS-TEXT": "Wenn Sie Bedingungen aktivieren, können Sie verzweigte Workflows erstellen und Verbindungen zwischen den Schritten bearbeiten.",
                    "SELECT": "Auswählen",
                    "ENTER": "Enter",
                    "CONTENT-PAGE-WARNING-TEXT": "Möchten Sie Bedingungen wirklich aktivieren?",
                    "CONTENT-PAGE-IMPORTANT-WARNING-TEXT": "VORSICHT: Durch das Aktivieren von Bedingungen wird die Funktion „Inhaltsseite“ in diesem Workflow dauerhaft deaktiviert.",
                    "CONFIRM": "Ja",
                    "INITIAL-STEP-CHANGE-TEXT": "Sie können den Startschritt ändern, indem Sie hier klicken",
                    "INITIAL-STEP-CHANGE-WARNING-TEXT": "Dieser Schritt kann kein Anfangsschritt sein, da es Schritte gibt, die mit diesem Schritt verbunden sind.",
                    "INVALID-DATA": "Dieser Schritt kann aufgrund ungültiger Daten nicht automatisch gespeichert werden.",
                    "ALREADY-CONNECTED": "Sie können keine Verbindung zwischen bereits verbundenen Schritten erstellen."
                },
                "HEADER-TITLES": {
                    "CLOSE-WORKFLOW": "Workflow schließen",
                    "PUBLISH-WORKFLOW": "Workflow veröffentlichen",
                    "DELETE-USER": "User löschen",
                    "DELETE-WORKFLOW": "Workflow löschen",
                    "WARNING": "Warnung",
                    "DELETE-FILE": "Datei löschen",
                    "DELETE-SECTION": "Abschnitt löschen",
                    "DELETE-STEP": "Schritt löschen",
                    "LOGOUT": "Logout",
                    "LICENCE-WARNING": "Lizenz Benachrichtigung",
                    "DUPLICATE-WORKFLOW": "Workflow duplizieren",
                    "SELECT-DEFAULT-LANGUAGE": "Wählen Sie Standardsprache",
                    "SWITCH-MODE": "Modus wechseln"
                },
                "LANGUAGE": {
                    "SEARCH": "Suchen",
                    "ADDED": "Hinzugefügt",
                    "DEFAULT": "Default",
                    "NOT-ADDED": "nicht hinzugefügt",
                    "LANGUAGE-INFO-TEXT": "Erstellen Sie einen mehrsprachigen Workflow, den Ihre User in verschiedenen Sprachen durchführen können. Wählen Sie zudem eine ihrer hinzugefügten Sprachen als Default-Sprache aus, um den Workflow standardmäßig in dieser Sprache anzuzeigen.",
                    "SELECT-LANGUAGE": "Sprache auswählen",
                    "CHECK-LANGUAGE": "Sie haben nach der automatischen Übersetzung Änderungen vorgenommen. Bitte vergessen Sie nicht, alle Sprachen anzukreuzen!",
                    "DELETE-LANGUAGE-OR-NOT": "Sind Sie sicher, dass Sie die Sprache löschen möchten? Alle Inhalte in der ausgewählten Sprache gehen verloren."
                },
                "DELETE": "Löschen",
                "WORKFLOW-NOT-FOUND": "Mit dem Link verknüpfter Workflow wurde nicht gefunden",
                "SAVE-SUCCESSFUL": "Speichern ist erfolgreich",
                "SAVE-ERROR": "Fehler speichern",
                "CLONED": "Erfolgreich geklont",
                "REPORT-SUBMITTED-BEFORE": "Der Bericht wurde bereits eingereicht"
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "Öffentlichen Zugriff verwalten",
                "MANAGE-PUBLIC-ACCESS-TEXT": "Sie können die Freigabe dieses Workflows beenden, indem Sie den öffentlichen Zugriff löschen.",
                "GENEATE-ACCESS-TEXT": "Mit Easy Access generieren Sie einen öffentlichen Link und einen QR-Code für diesen Workflow. Dies ermöglicht Ihren Usern den einfachen und direkten Zugang zu diesem Workflow.",
                "ENABLE-PASSWORD": "Passwort hinzufügen",
                "GENERATE-ACCESS": "Easy Access generieren",
                "LINK": "Link",
                "COPY": "Kopieren",
                "QR-CODE": "QR-Code",
                "DOWNLOAD": "Download",
                "SECURITY": "Sicherheit",
                "PASSWORD-PROTECTED": "Passwortgeschützt",
                "PUBLIC": "Öffentlich",
                "DELETE-ACCESS": "Öffentlichen Zugriff löschen",
                "EASY-ACCESS-TITLE": "{{ shortName }}-Workflow Easy Access",
                "OPEN-WORKFLOW-NAME": "Folgender Workflow wird geöffnet",
                "GUEST-EMAIL": "Gast-E-Mail",
                "REQUIRED": "Dieses Feld ist erforderlich",
                "GUEST-PASSWORD": "Passwort für Gäste",
                "OPEN": "ÖFFNEN",
                "OPEN-APP": "Öffnen Sie diesen Workflow in der App, für eine bessere Nutzerfreundlichkeit.",
                "COPY-LINK-TEXT": "Kopieren Sie diesen Link in die Zwischenablage, um den Workflow zu öffnen, sobald die App gestartet wird.",
                "DOWNLOAD-APP": "APP DOWNLOAD",
                "DOWNLOAD-SMARTGLASSES-APP": "APP FÜR SMARTGLASSES HERUNTERLADEN",
                "OR": "ODER",
                "CONTINUE-WITH-BROWSER": "Fahren Sie im Browser fort",
                "PASSWORD-PROTECTED-TEXT": "Wenn das Passwort aktiviert ist, haben User, die über den öffentlichen Link oder den QR-Code verfügen, nur Zugriff auf den Workflow, nachdem sie das Passwort eingegeben haben.",
                "CREATE-PASSWORD": "Passwort erstellen",
                "ENTER-EMAIL": "Geben sie ihre E-Mail Adresse ein",
                "ENTER-WORKFLOW-PASSWORD": "Geben Sie das Passwort des Workflows ein",
                "DELETE-QR-TEXT": "Um den Sicherheitstyp von Easy Access zu ändern, sollten Sie Easy Access löschen und erneut generieren.",
                "LOADING-WORKFLOW": "Workflow wird geladen...",
                "UNABLE-TO-LOAD": "Workflow kann nicht geladen werden",
                "RETRY": "Wiederholen",
                "GUEST-ACCESS": {
                  "TOKEN-MISSING": "Token fehlt oder ist ungültig",
                  "ID-MISSING": "Workflow-ID oder Basis-URL fehlt",
                  "WORKFLOW-NOT-PUBLISHED": "Workflow ist nicht veröffentlicht",
                  "PUBLIC-ACCESS": "Der öffentliche Zugang ist bereits vorhanden",
                  "NO-PUBLIC-ACCESS": "Kein öffentlicher Zugang"
                },
                "QR-INFORMATION": "QR-Informationen"
            },
            "WORK-ORDERS": {
                "TITLE": "Arbeitsaufträge",
                "CREATE-WORK-ORDER": "Arbeitsauftrag erstellen",
                "EDIT-WORK-ORDER": "Arbeitsauftrag bearbeiten",
                "EDIT": "Bearbeiten",
                "CREATE": "Erstellen",
                "DELETE": "Löschen",
                "SAVE-CHANGES": "Änderungen speichern",
                "TO-DO": "Offen",
                "DONE": "Erledigt",
                "DETAILS": "Details",
                "COMMENTS": "Kommentare",
                "ASSIGNED-EXPERTS-FOR-REMOTE-CALL": "Zugewiesene Experten für Remote-Call",
                "EMPTY-LIST": "Keine Arbeitsaufträge gefunden.",
                "SELECT-PRIORITY": "Priorität",
                "PRIORITY": {
                    "high": "Hoch",
                    "medium": "Mittel",
                    "low": "Niedrig"
                },
                "SELECT-STATUS": "Status",
                "STATUS": {
                    "open": "Offen",
                    "in-progress": "In Bearbeitung",
                    "on-hold": "In Wartestellung",
                    "done": "Erledigt"
                },
                "SELECT-ASSIGNEE": "Zugewiesen",
                "SELECT-LABEL": "Label",
                "SEARCH": "Suche",
                "NO-ITEMS-FOUND": "keine Einträge gefunden",
                "SELECT-DUE-DATE": "Fälligkeitsdatum",
                "SELECT-RECURRENCE": "Wiederauftreten",
                "RECURRENCE": {
                    "none": "Keine",
                    "daily": "Täglich",
                    "weekly": "Wöchentlich",
                    "monthly": "Monatlich"
                },
                "ITEMS": {
                    "ID": "ID",
                    "PRIORITY": "Priorität",
                    "DUE-DATE": "Fälligkeitsdatum",
                    "TASK-NAME": "Aufgabenname",
                    "STATUS": "Status",
                    "ADD-DUE-TIME": "Fälligkeitszeit hinzufügen",
                    "CLEAR-DUE-TIME": "Klare Zeit",
                    "RECURRENCE": "Wiederauftreten",
                    "DESCRIPTION": "Beschreibung",
                    "FILES": "Dateien",
                    "ASSIGNED-WORKFLOWS": "Zugewiesene Workflows",
                    "ADD-WORKFLOW": "Workflow hinzufügen",
                    "ASSIGNED-TO": "Zugewiesen an",
                    "SELECT-USER": "Nutzer wählen",
                    "ACTIVITY": "Aktivität"
                },
                "ACTIVITY": {
                    "dueDate": "Fälligkeitsdatum",
                    "assignedTo": "zugewiesen an",
                    "status": "Status",
                    "priority": "Priorität",
                    "assignedExpert": "zugewiesener Experte",
                    "files": "Dateien",
                    "labels": "Labels",
                    "description": "Beschreibung",
                    "name": "Name",
                    "assignedWorkflows": "zugewiesene Workflows",
                    "recurrence": "Wiederholung",
                    "UPDATED": "hat aktualisiert",
                    "WORK-ORDER-CREATED": "hat den Arbeitsauftrag erstellt"
                },
                "WARNING": {
                    "DELETE-WORK-ORDER-TITLE": "Arbeitsauftrag löschen",
                    "DELETE-WORK-ORDER-TEXT": "Sind Sie sicher, dass Sie diesen Arbeitsauftrag löschen möchten?",
                    "UNASSIGN-WORKFLOW-TITLE": "Workflow nicht zuweisen",
                    "UNASSIGN-WORKFLOW-TEXT": "Sind Sie sicher, dass Sie diesen Workflow nicht zuweisen möchten?"
                }
            },
            "TICKETS": {
                "TITLE": "Tickets",
                "NEW_TICKET": "Neues Ticket",
                "CREATE_TICKET": "Ticket erstellen",
                "EDIT_TICKET": "Ticket bearbeiten",
                "TICKET_DETAILS": "Ticketdetails",
                "TICKET_CREATED": "Ticket erfolgreich erstellt",
                "TICKET_UPDATED": "Ticket erfolgreich aktualisiert",
                "TICKET_DELETED": "Ticket erfolgreich gelöscht",
                "DELETE_CONFIRM": "Sind Sie sicher, dass Sie dieses Ticket löschen möchten?",
                "ALL_ROOMS": "Alle Räume",
                "ALL_CREATORS": "Alle Ersteller",
                "ALL_ASSIGNEES": "Alle Verantwortliche",
                "ALL_STATUSES": "Alle Status",
                "ALL_PRIORITIES": "Alle Prioritäten",
                "CREATED_BETWEEN": "Erstellt zwischen",
                "NO_TICKETS": "Keine Tickets gefunden",
                "TICKET_TITLE": "Titel",
                "ROOM": "Raum",
                "WORK_GROUP": "Arbeitsgruppe",
                "ALL_WORK_GROUPS": "Alle Arbeitsgruppen",
                "CREATED_BY": "Erstellt von",
                "CREATED_ON": "Erstellt am",
                "STATUS": "Status",
                "STATUS_OPEN": "Offen",
                "STATUS_IN_PROGRESS": "In Bearbeitung",
                "STATUS_CLOSED": "Geschlossen",
                "STATUS_IN-PROGRESS": "In Bearbeitung",
                "STATUS_UPDATED": "Status erfolgreich aktualisiert",
                "LOW": "Niedrig",
                "MEDIUM": "Mittel",
                "HIGH": "Hoch",
                "PRIORITY_LOW": "Niedrig",
                "PRIORITY_MEDIUM": "Mittel",
                "PRIORITY_HIGH": "Hoch",
                "TYPE": "Typ",
                "PRIORITY": "Priorität",
                "DESCRIPTION": "Beschreibung",
                "RESOLUTION": "Lösung",
                "FOLLOWUP_DATE": "Follow-up-Datum",
                "ASSIGNEE": "Verantwortlicher",
                "CREATE": "Erstellen",
                "SAVE": "Speichern",
                "SAVE_CHANGES": "Änderungen speichern",
                "CANCEL": "Abbrechen",
                "DELETE": "Löschen",
                "DELETED": "Erfolgreich gelöscht",
                "DELETE_ERROR": "Fehler beim Löschen des Tickets",
                "EDIT": "Bearbeiten",
                "TAB_ACTIVE": "Aktiv",
                "TAB_CLOSED": "Geschlossen",
                "UPDATE_SUCCESS": "Ticket erfolgreich aktualisiert",
                "CREATE_SUCCESS": "Ticket erfolgreich erstellt",
                "UPDATE_ERROR": "Fehler beim Aktualisieren des Tickets",
                "CREATE_ERROR": "Fehler beim Erstellen des Tickets",
                "LOAD_ERROR": "Fehler beim Laden der Ticketdetails",
                "TITLE_REQUIRED": "Titel ist erforderlich",
                "DESCRIPTION_REQUIRED": "Beschreibung ist erforderlich",
                "FORM_INVALID": "Bitte füllen Sie alle Pflichtfelder aus",
                "DETAILS": "Details",
                "ATTACHED_SESSIONS": "Verknüpfte Sessions",
                "ADD_SESSION": "Session hinzufügen",
                "SESSION_COUNT": "Anzahl der Sessions",
                "TOTAL_DURATION": "Gesamtdauer",
                "PARTICIPANTS": "Teilnehmer",
                "DATE": "Datum",
                "ROOM_NAME": "Arbeitsgruppe",
                "DURATION": "Dauer",
                "SESSIONS": "Sessions",
                "GUEST": "Gast",
                "NO_SESSIONS": "Keine Sessions gefunden",
                "NO_ATTACHED_SESSIONS": "Keine verknüpften Sessions",
                "DETACH_SESSION": "Session trennen",
                "DETACH_SESSION_CONFIRM": "Möchten Sie diese Session wirklich vom Ticket trennen?",
                "DETACH": "Trennen",
                "DETACH_SUCCESS": "Session erfolgreich getrennt",
                "ATTACH_SUCCESS": "Ticket erfolgreich geändert",
                "SESSION_ALREADY_ATTACHED": "Diese Session ist bereits mit einem anderen Ticket verknüpft",
                "WORK_GROUP_CHANGE_WARNING": "Arbeitsgruppe ändern",
                "WORK_GROUP_CHANGE_CONFIRM": "Dieses Ticket hat {{count}} verknüpfte Session(s) aus der aktuellen Arbeitsgruppe. Wenn Sie die Arbeitsgruppe ändern, werden alle diese Sessions automatisch getrennt. Möchten Sie fortfahren?",
                "WORK_GROUP_CHANGE_CONFIRM_SINGULAR": "Dieses Ticket hat 1 verknüpfte Session aus der aktuellen Arbeitsgruppe. Wenn Sie die Arbeitsgruppe ändern, wird diese Session automatisch getrennt. Möchten Sie fortfahren?",
                "FILES": {
                    "TITLE": "Dateien",
                    "DOWNLOAD": "Herunterladen",
                    "DOWNLOAD_STARTED": "Download gestartet",
                    "NO_FILES": "Keine Dateien gefunden",
                    "UPLOAD_SUCCESS": "Datei erfolgreich hochgeladen",
                    "UPLOAD_ERROR": "Datei konnte nicht hochgeladen werden"
                },
                "CHAT_TIMELINE": {
                    "TITLE": "Chat+Zeitleiste",
                    "EMPTY": "Noch keine Nachrichten oder Aktivitäten",
                    "PLACEHOLDER": "Nachricht eingeben... Verwenden Sie @ um Benutzer zu erwähnen",
                    "SEND": "Senden",
                    "SEND_ERROR": "Nachricht konnte nicht gesendet werden",
                    "ATTACH_FILE": "Datei anhängen",
                    "PASTE_UPLOAD_TITLE": "Datei hochladen",
                    "PASTE_UPLOAD_CONFIRM": "Do you want to upload the file from clipboard?",
                    "PASTE_UPLOAD_CONFIRM_BUTTON": "Hochladen",
                    "SESSION_ATTACHED": "Remote-Session durchgeführt",
                    "FILE_ADDED": "Datei hinzugefügt",
                    "UPLOADED_BY": "hochgeladen",
                    "TODAY": "Heute",
                    "YESTERDAY": "Gestern",
                    "SYSTEM": {
                        "DEFAULT_ACTOR": "Ein Benutzer",
                        "STATUS_CHANGED": "{{ actor }} hat den Status von {{ from }} auf {{ to }} geaendert.",
                        "PRIORITY_CHANGED": "{{ actor }} hat die Prioritaet von {{ from }} auf {{ to }} geaendert.",
                        "DATE_CHANGED": "{{ actor }} hat das Datum von {{ from }} auf {{ to }} geaendert.",
                        "ASSIGNEE_CHANGED": "{{ actor }} hat den Zustaendigen von {{ from }} auf {{ to }} geaendert.",
                        "ROOM_CHANGED": "{{ actor }} hat den Raum von {{ from }} auf {{ to }} geaendert.",
                        "TYPE_CHANGED": "{{ actor }} hat den Typ von {{ from }} auf {{ to }} geaendert.",
                        "TITLE_UPDATED": "{{ actor }} hat den Titel aktualisiert.",
                        "DESCRIPTION_UPDATED": "{{ actor }} hat die Beschreibung aktualisiert.",
                        "RESOLUTION_UPDATED": "{{ actor }} hat die Loesung aktualisiert.",
                        "EXTRA_FIELDS_UPDATED": "{{ actor }} hat weitere Felder aktualisiert."
                    }
                },
                "EXPORT_PDF": {
                    "BUTTON": "Exportieren",
                    "TITLE": "Ticket exportieren",
                    "SUBTITLE": "Wählen Sie aus, was im Bericht enthalten sein soll.",
                    "ATTACHED_SESSIONS": "Verknüpfte Sessions",
                    "FILES": "Dateien",
                    "CHAT": "Chat",
                    "IMAGES_IN_PDF": "Bilder in PDF einbetten",
                    "IMAGES_OPTIMIZED": "Bilder werden fuer die PDF-Groesse optimiert.",
                    "IMAGE_COMPRESSION_TOOLTIP": "Bilder können komprimiert werden, um die Dateigroesse zu optimieren.",
                    "SECTION_INCLUDE": "EINBEZIEHEN",
                    "SECTION_OUTPUT": "AUSGABE",
                    "OUTPUT_FORMAT_LABEL": "Ausgabeformat:",
                    "OUTPUT_FORMAT_ZIP": "ZIP (PDF + Anhaenge)",
                    "OUTPUT_FORMAT_PDF": "Nur PDF",
                    "ESTIMATED_SIZE": "Geschaetzte Dateigroesse:",
                    "ZIP_NOTICE": "Wenn Dateien ausgewählt sind, werden PDF und Dateien als ZIP heruntergeladen.",
                    "CANCEL": "Abbrechen",
                    "EXPORT": "Bericht exportieren",
                    "EXPORTING": "Wird erstellt...",
                    "MIN_SELECTION": "Wählen Sie mindestens eine Option aus.",
                    "DETAILS_TITLE": "Details",
                    "SESSIONS_TITLE": "Verknüpfte Sessions",
                    "FILES_TITLE": "Dateien",
                    "CHAT_TITLE": "Chat+Zeitleiste",
                    "NO_ITEMS": "Keine Daten",
                    "FILE_TYPE": "Typ",
                    "FILE_SIZE": "Groesse",
                    "FILE_UPLOADER": "Hochgeladen von",
                    "CHAT_TIME": "Zeit",
                    "CHAT_USER": "Absender",
                    "CHAT_MESSAGE": "Nachricht",
                    "SESSION_HELD": "Remote-Session durchgeführt",
                    "FILE_SHARED": "Datei geteilt: {{ file }}",
                    "FILE_SHARED_BY": "Hat eine Datei geteilt: {{ file }}"
                }
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "Video-Flow",
                "CREATE-VIDEO-FLOW": "Video-Flow erstellen",
                "CREATE-VIDEO-FLOW-PAGE": "Video-Flow erstellen",
                "CREATED-BY-AI": "Von KI erstellt",
                "VERSION": "Version",
                "NO-VIDEO-FLOWS-FOUND": "Keine Video-Flows gefunden",
                "CLEAR-ALL": "Alle löschen",
                "CONFIRM-VIDEO": "Video bestätigen",
                "CONFIRM-VIDEO-TITLE": "Videokonvertierung bestätigen",
                "CONFIRM-VIDEO-MESSAGE": "Möchten Sie diesen Videoablauf wirklich in einen Workflow umwandeln? Nach der Bestätigung können Sie das Video nicht mehr bearbeiten.",
                "CONFIRM-VIDEO-BUTTON": "Bestätigen & Konvertieren",
                "MAKE-WORKFLOW-SUCCESSFUL": "Erfolgreich in Workflow umgewandelt",
                "MAKE-WORKFLOW-ERROR": "Umwandlung in Workflow fehlgeschlagen",
                "UPLOAD-VIDEO-DESCRIPTION": "Laden Sie Ihr Video hoch, um automatisch eine schrittweise Workflow-Anleitung zu erstellen.",
                "VIDEO-DURATION-LIMIT": "Die Videodauer darf 30 Minuten nicht überschreiten.",
                "VIDEO-UPLOADED-SUCCESS": "Video erfolgreich hochgeladen!",
                "SELECT-VIDEO": "Video auswählen",
                "CHANGE-VIDEO": "Video ändern",
                "CREATE-BUTTON": "Erstellen",
                "AI-PROCESSING": "KI-Verarbeitung läuft",
                "SPLITTING-VIDEO": "Video in Segmente aufteilen",
                "TRANSCRIBING-VIDEO": "Videoinhalt transkribieren",
                "PROCESS-WARNING": "Dieser Vorgang kann bis zu 10 Minuten dauern. Bitte schließen Sie dieses Fenster nicht."
            }
        },
        "NAVBAR": {
            "LOGOUT": {
                "TEXT": "Log out",
                "TEXT-MESSAGE": {
                    "MESSAGE": "Möchten Sie sich wirklich abmelden?",
                    "CONFIRM": "Logout"
                }
            }
        },
        "SIDEBAR": {
            "WORK-ORDERS": "Arbeitsaufträge",
            "REMOTE-ASSISTANCE": "Remote Assistance",
            "WORKFLOWS": "Workflows",
            "VIDEO-FLOWS": "Video-Flows",
            "USERS": "User & Gruppen",
            "REPORTS": "Reports",
            "DRAFTS": "Reports",
            "ANALYTICS": "Analytik",
            "SETTINGS": "Einstellungen",
            "SWITCH-ADMIN-PANEL": "Wechseln Sie zum Editor",
            "SWITCH-USER-PANEL": "Wechseln Sie zum Benutzerbereich",
            "SWITCH-ADMIN-PANEL-TEXT": "Um Workflows zu erstellen und zu bearbeiten, wechseln Sie vom Benutzerbereich zum Editor.",
            "SWITCH-USER-PANEL-TEXT": "Um Workflows durchzuführen, wechseln Sie vom Editor zum Benutzerbereich."
        },
        "USER-WORKFLOW": {
            "ADD": "HINZUFÜGEN",
            "INVALID-EMAIL": "Ungültige E-Mail",
            "SEND-REQUEST": "Anfrage senden an:",
            "SEND-REPORT": "Bericht senden an:",
            "REMOVE": "ENTFERNEN",
            "APPROVAL-REQUEST": "Genehmigungsanfrage",
            "REQUEST-SENDED-TEXT": "Ihre Genehmigungsanfrage wurde erfolgreich an die aufgeführten E-Mail-Adressen gesendet",
            "CLOSE": "SCHLIESSEN",
            "LICENCE-LIMIT": "Ihr Konto hat die maximale Anzahl an Workflow-Übermittlungen erreicht. Der Kontoadministrator sieht den Bericht, sobald die Lizenz aktualisiert wurde.",
            "REQUEST-PENDING": "Genehmigungsantrag ausstehend",
            "REQUEST-APPROVAL": "Fordern Sie die Genehmigung für den Bericht an",
            "REQUEST-REPORT": "Bericht nach Genehmigung senden",
            "SEND-REQUEST-TITLE": "ANFRAGE SENDEN",
            "SEND-REPORT-TITLE": "BERICHT SENDEN",
            "TASK-TO-COMPLETE": "Durchzuführende Schritte",
            "SELECT-LANGUAGE": "Sprache auswählen",
            "CONTENT-LANGUAGE": "Inhaltssprache:",
            "ESTIMATED-DURATION": "Geschätzte Dauer:",
            "DELETE": "Löschen",
            "DELETE-APPROVAL":"Sind Sie sicher, dass Sie löschen möchten?",
            "EMAIL-INVALID": "Das E-Mail-Format ist ungültig",
            "MISSING-EQUIPMENT": "Fehlende Ausrüstung",
            "PROTECTED-EQUIPMENT": "Bitte verwenden Sie die erforderliche persönliche Schutzausrüstung",
            "CONTINUE-WITH-QR-WARNING-TEXT": "Sie sind dabei, Ihren Workflow als vorab ausgefüllt zu übergeben. Es werden ein Link und ein QR-Code generiert, damit auf den vorab ausgefüllten Workflow zugegriffen und dieser später fortgesetzt werden kann. Sobald der QR-Code generiert wurde, können die vorab ausgefüllten Schritte nicht mehr bearbeitet werden. Sind Sie sicher, dass Sie fortfahren möchten?",
            "CONTINUE-WITH-QR-TITLE": "ÜBERTRAGEN SIE DEN VORGEFÜLLTEN WORKFLOW",
            "TABLE-OF-CONTENTS": "Inhaltsverzeichnis",
            "CALL-EXPERT": "Experten anrufen",
            "HAND-OVER": "Übertragen",
            "CANCEL": "ABBRECHEN",
            "CALL": "ANRUF",
            "SAVE-CHANGES": "Änderungen speichern",
            "CALL-PERMISSION-WARNING": "Sie sind nicht berechtigt, einen Experten anzurufen. Bitte kontaktieren Sie Ihren Systemadministrator.",
            "SELECT-EXPERT-TEXT": "Wählen Sie den Experten aus, den Sie anrufen möchten:",
            "ERRORS": {
                "INTEGRATION-NOT-FOUND": "Integration nicht gefunden"
            },
            "QR-NOT-MATCHED": "QR-Code stimmt nicht überein",
            "STEP-FILES": {
                "TITLE": "STEP-DATEIEN"
            }
        },
        "LOBBY" : {
            "LOBBY_SHARED": {
                "ONGOING_CALLS_TITLE": "Laufende Anrufe",
                "ROOMS_TITLE": "Ihre Arbeitsgruppen",
                "UPCOMING_MEETINGS_TITLE" : "Kommende Meetings",
                "PREVIOUS_MEETINGS_TITLE" : "Vergangene Meetings",
                "SCHEDULE_MEETING": "Ein Meeting planen",
                "INSTANT_GUEST_ACCESS": "Sofortiger Gastzugang",
                "INSTANT_GUEST_ACCESS_NO_CALLING": "Sie haben keine Berechtigung zum Anrufen. Bitte wenden Sie sich an Ihren Administrator.",
                "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "Sie haben keine Berechtigung, einen Gastzugangslink zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
                "INSTANT_GUEST_ACCESS_NO_PERM": "Sie haben keine Berechtigung zum Anrufen oder zum Erstellen eines Gastzugangslinks. Bitte wenden Sie sich an Ihren Administrator.",
                "LINK_UNAVAILABLE": "Link nicht verfügbar",
                "JOIN" : "BEITRETEN",
                "CANCEL": "LÖSCHEN",
                "REMOVE": "ENTFERNEN",
                "NO_ROOM": "Ihnen sind keine Arbeitsgruppen zugeordnet",
                "NO_MEETING": "Sie haben keine geplanten Meetings.",
                "NO_PREV_MEETING": "Sie haben keine vergangenen Meetings.",
                "NO_OTHER_USERS": "Keine anderen User",
                "SHOW_MORE": "{{ count }} weitere anzeigen",
                "SHOW_LESS": "weniger anzeigen",
                "REMOTE_ASSISTANCE": "Remote Assistance",
                "NEW_REMOTE_SESSION": "Neue Remote-Session",
                "START_INSTANT_CALL": "Starten Sie einen Sofortanruf",
                "OVERVIEW": "Überblick",
                "MEETINGS": "Meetings",
                "WORK_GROUPS": "Arbeitsgruppen",
                "HISTORY": "Verlauf",
                "JOIN_REMOTE_SESSION": "Einer Remote-Session beitreten",
                "JOIN_REMOTE_SESSION_DESCRIPTION": "Geben Sie einen freigegebenen Link ein, um an einem geplanten Meeting teilzunehmen.",
                "ENTER_LINK_PLACEHOLDER": "Link eingeben",
                "JOIN_BUTTON": "Beitreten",
                "UPCOMING_SCHEDULED_MEETINGS": "Anstehende geplante Meetings",
                "VIEW_ALL_MEETINGS": "Alle Meetings anzeigen"
            },
            "SCHEDULE_MEETING_MODAL": {
                "TITLE": "Ein Meeting planen",
                "MEETING_TITLE": "Titel*",
                "MEETING_TITLE_REQUIRED": "Titel erforderlich",
                "START_DATE": "Start",
                "END_DATE": "Ende",
                "CLOSE": "Schliessen",
                "SCHEDULE_SEND": "Planen & Senden",
                "SCHEDULE": "Planen",
                "CANNOT_SCHEDULE": "Beim Planen des Meetings ist ein Fehler aufgetreten.",
                "CANNOT_CANCEL_MEETING": "Beim Löschen des Meetings ist ein Fehler aufgetreten.",
                "ENTER_USERS": "User eingeben",
                "SEND_INVITATIONS": "Einladungen verschicken",
                "INVITATION_EMAIL_LANG": "Sprache der Einladungsemail",
                "SHARE_AFTER": "Der Besprechungslink kann auch nach der Planung geteilt werden."
            },
            "CANCEL_MEETING_MODAL": {
                "CANCEL_TITLE": "Besprechung absagen",
                "REMOVE_TITLE": "Besprechung entfernen",
                "CANCEL_MESSAGE": "Sind Sie sicher, dass Sie die Besprechung absagen möchten?",
                "REMOVE_MESSAGE": "Sind Sie sicher, dass Sie die Besprechung entfernen möchten?",
                "CLOSE": "Schliessen",
                "PROCEED": "Fortfahren"
            },
            "CONTACTS": {
                "TITLE": "Userliste",
                "NO_PERMISSION": "Sie haben keine Berechtigung die Userliste einzusehen und andere User anzurufen.",
                "NO_CONTACT": "Die Liste aller User ist leer.",
                "SELECT_MULTI": "Mehrere auswählen",
                "CALL": "Anruf",
                "ADMIN": "Admin",
                "COADMIN": "Co-Admin",
                "EXPERT": "Expert",
                "SUBSCRIBER": "Subscriber",
                "USER": "User",
                "NAME": "Name",
                "USERNAME": "Username",
                "ROLE": "Rolle",
                "NO_EXPERT": "Bitte wählen Sie mindestens einen Experten aus, um einen Anruf zu tätigen.",
                "NAME_USERNAME": "Name oder Username",
                "ALL_ROLES": "Alle Rollen",
                "SEARCH_PLACEHOLDER": "Name suchen",
                "INSTANT_CALL_DESCRIPTION": "Stellen Sie einen Sofortanruf mit einem Benutzer her oder wählen Sie mehrere Benutzer aus, um einen Gruppenanruf zu tätigen."
            },
            "SESSIONS": {
                "TITLE": "Sessions",
                "DATE": "Erstellt am",
                "DURATION": "Gesamtdauer",
                "ROOM_NAME": "Arbeitsgruppe",
                "NO_SESSIONS": "Die Liste aller Sessions ist leer.",
                "PARTICIPANTS": "Teilnehmer",
                "EXPORT": "Sessionexport",
                "STATUS": "Status",
                "ON_GOING": "Laufend",
                "ENDED": "Beendet",
                "MORE": "mehr",
                "FILES": "Dateien",
                "CHAT": "Chat",
                "SESSION_FILES": {
                    "MULTIPLE_SELECTION": "Mehrere auswählen",
                    "DOWNLOAD": "Herunterladen",
                    "DOWNLOAD_STARTED_SOON": "Der Download wird in Kürze gestartet.",
                    "DOWNLOAD_FAILED": "Download fehlgeschlagen",
                    "NO_FILE_IS_ADDED": "In dieser Session wurden keine Dateien hinzugefügt oder bearbeitet.",
                    "SUCCESS_MESSAGE": "Die Dateien wurden erfolgreich heruntergeladen."
                },
                "ATTACHED_TICKET": "Verknüpftes Ticket",
                "SESSION_DETAILS": "Sitzungsdetails",
                "BACK": "Zurück",
                "GET_SESSION_EXPORT": "Session-Export abrufen",
                "ATTACH_TO_TICKET": "An Ticket anhängen"
            },
            "ARCHIVES": {
                "ARCHIVE_LIST": {
                    "REFRESH": "Aktualisieren",
                    "LOADING": "Laden von Videoanrufaufzeichnungen",
                    "NO_ARCHIVE_MESSAGE": "Es gibt keine Aufzeichnung von Videoanrufen.",
                    "NAME": "Name",
                    "CREATED_AT": "Erstellt am",
                    "STORAGE": "Speicherort",
                    "DURATION": "Dauer",
                    "ARCHIVES": "Videoanrufaufzeichnungen",
                    "SIZE": "Größe",
                    "STATUS": "Status",
                    "AVAILABLE": "verfügbar",
                    "DISCONNECTED": "getrennt",
                    "DELETED": "gelöscht",
                    "EXPIRED": "abgelaufen",
                    "WAITING": "wartend",
                    "FAILED": "gescheitert",
                    "DOWNLOAD": "Herunterladen",
                    "PLAY": "Abspielen",
                    "DELETE": "Löschen",
                    "DOWNLOAD_ARCHIVE": {
                        "TITLE": "Aufzeichnung herunterladen",
                        "GENERATING": "Download-URL erstellen",
                        "GENERATED": "Die Download-URL wurde erstellt.",
                        "CANNOT_GENERATED": "Die Download-URL konnte nicht erstellt werden.",
                        "DOWNLOAD": "Herunterladen",
                         "CLOSE": "Schließen"
                    },
                    "DELETE_ARCHIVE": {
                        "TITLE": "Aufzeichnung löschen",
                        "MESSAGE": "Die Aufzeichnung des Videoanrufs wird gelöscht.",
                        "CAUTION": "ACHTUNG: Diese Aufzeichnung wird auch auf Ihrem Azure Cloud-Speicher gelöscht.",
                        "CANCEL": "Abbrechen",
                        "DELETE": "Löschen"
                    }
                }
            },
            "CONVERTER": {
                "TITLE": "Konverter",
                "STP_ONLY": "Es werden nur die Dateiformate .stp und .step unterstützt.",
                "ERROR_UPLOAD": "Beim Hochladen der Datei ist ein Fehler aufgetreten.",
                "DRAG": "Ziehen Sie Ihre Datei per Drag & Drop hierher",
                "OR": "oder",
                "CHOOSE": "Datei wählen",
                "CONVERT": "Konvertieren",
                "SUPPORTED": "Unterstützte Dateiformate:",
                "BACK": "Zurück",
                "DOWNLOAD": "Download",
                "ERROR_LOAD": "Beim Laden des Objekts ist ein Fehler aufgetreten."
            },
            "WHATSNEW": {
                "WHATSNEW_TITLE": "Was gibt's Neues",
                "NO_UNREAD_UPDATE": "Sie haben keine Feature-Updates verpasst"
            },
            "JOIN_MODAL": {
                "JOIN" : "BEITRETEN",
                "CALL": "ANRUF",
                "CANCEL": "ABBRECHEN",
                "MIRROR_VIDEO": "Video spiegeln",
                "PREFERRED_RESOLUTION": "Bevorzugte Auflösung",
                "RESOLUTION_NOTE": "Anmerkung: Sofern Ihr Gerät die gewünschte Auflösung nicht unterstützt, wird die nächst-größere verwendet.",
                "CAM_MIC_PERM_REQUIRED": "Freigabe von Kamera und Mikrofon erforderlich",
                "CAM_MIC_PERM_DENIED": "Zugriff auf Kamera oder Mikrofon verweigert",
                "CAM_MIC_CANT_ACCESS": "Wir können nicht auf Ihre Kamera und Ihr Mikrofon zugreifen.",
                "JOIN_CAM_OFF": "Mit ausgeschalteter Kamera beitreten",
                "JOIN_MIC_OFF": "Mit ausgeschaltetem Mikrofon beitreten",
                "JOIN_CAM_MIC_OFF": "Mit ausgeschalteter Kamera und ausgeschaltetem Mikrofon beitreten",
                "JOIN_NO_DEVICE": "Trotz nicht vorhandenem Mikrofon/Kamera teilnehmen",
                "ALLOW_ACCESS": "Bitte erteilen Sie in den Browsereinstellungen den Zugriff auf Ihre Kamera und Ihr Mikrofon (Danach können Sie der Session trotzdem ohne Kamera und Mikrofon beitreten).",
                "TRY_AGAIN": "Bitte erneut versuchen / Aktualisieren Sie diese Seite und wählen Sie 'Erlauben', wenn der Browser Sie darum bittet."
            },
            "NO_DEVICE_MODAL": {
                "TITLE": "Kein Gerät gefunden",
                "JOIN_BODY": "Dieses Gerät ist weder mit einem Mikrofon, noch mit einer Kamera verbunden. Andere User können Sie somit über dieses Gerät weder hören noch sehen. Wollen Sie dennoch der Session beitreten?",
                "CALL_BODY": "Dieses Gerät ist weder mit einem Mikrofon, noch mit einer Kamera verbunden. Andere User können Sie somit über dieses Gerät weder hören noch sehen. Wollen Sie trotzdem anrufen?",
                "CANCEL": "Abbrechen",
                "JOIN": "Trotzdem Beitreten",
                "CALL": "Trotzdem Anrufen"
            },
            "AGREEMENT_MODAL": {
                "TITLE": "Einverständniserklärung zur Speicherung und Verarbeitung personenbezogener Daten",
                "REJECTION_BUTTON": "Ablehnen",
                "AGREEMENT_BUTTON": "Zustimmen"
            },
            "CHECK_AGREEMENT_MODAL": {
                "TITLE": "Einwilligung widerrufen?",
                "ERROR": "Es ist ein Fehler aufgetreten.",
                "STATEMENT": "Solange Sie unsere Konditionen nicht akzeptieren, können Sie sich nicht im System anmelden.",
                "CANCEL_BUTTON": "Abbrechen",
                "PROCEED_BUTTON": "Fortfahren"
            },
            "JOIN_UNKNOWN_ERROR" : "Beim Betreten der Arbeitsgruppe ist ein Fehler aufgetreten.",
            "JOIN_CONCURRENT_ERROR" : "In Ihrem Konto wurde das Limit für gleichzeitig angemeldete User erreicht. Bitte wenden Sie sich an Ihren Administrator, um weitere Informationen zu erhalten.",
            "JOIN_EXPERT_CONCURRENT_ERROR" : "In Ihrem Konto wurde das Limit für gleichzeitig angemeldete Experten erreicht. Bitte wenden Sie sich an Ihren Administrator, um weitere Informationen zu erhalten.",
            "NO_TRAINING_LICENSE": "Es liegt ein Problem mit Ihrer Schulungsraumlizenz vor. Bitte wenden Sie sich an Ihren Administrator.",
            "TRAINING_LICENSE_EXPIRED": "Ihre Lizenz für Schulungsräume ist abgelaufen. Bitte wenden Sie sich an Ihren Administrator.",
            "ASK_TRAINING_HOST": "Beim Betreten des Schulungsraums ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Host.",
            "JOIN_CALL_IN_PROGRESS": "In Ihrem persönlichen Besprechungsraum findet ein Anruf statt.",
            "NOT_SUPPORTED_TITLE": "Inkompatibler Browser",
            "NOT_SUPPORTED_MESSAGE": "Bitte verwenden Sie Google Chrome, Mozilla Firefox, Safari oder Microsoft Edge (Version 79 oder neuer).",
            "NO_IOS_MESSAGE": "Ihr Browser ist nicht kompatibel. Bitte verwenden Sie die {{ appName }} Remote App oder Safari.",
            "IOS_VERSION_MESSAGE": "Ihr Browser ist nicht kompatibel. Bitte verwenden Sie die {{ appName }} Remote App.",
            "NOT_SUPPORTED_CLOSE": "Schließen",
            "IDLE_MODAL_TITLE": "Error",
            "IDLE_MODAL_MESSAGE": "Sie haben lange keine Aktion getätigt",
            "IDLE_MODAL_COUNT": "Sie werden in {{count}} Sekunden abgemeldet.",
            "IDLE_MODAL_OK": "Ich bin hier",
            "ARCHIVE_PERMISSION_MODAL": {
                "TITLE": "Aufnahme erlauben?",
                "MESSAGE": "Die Session wird aufgezeichnet. Sie müssen die Videoaufnahme erlauben, um dieser Session beizutreten.",
                "DENY": "Ablehnen",
                "ALLOW": "Erlauben"
            }
        },
        "ARCHIVES": {
            "ARCHIVE_LIST": {
                "REFRESH": "Aktualisieren",
                "LOADING": "Laden von Videoanrufaufzeichnungen",
                "NO_ARCHIVE_MESSAGE": "Es gibt keine Aufzeichnung von Videoanrufen.",
                "NAME": "Name",
                "CREATED_AT": "Erstellt am",
                "STORAGE": "Speicherort",
                "DURATION": "Dauer",
                "ARCHIVES": "Videoanrufaufzeichnungen",
                "SIZE": "Größe",
                "STATUS": "Status",
                "AVAILABLE": "verfügbar",
                "DISCONNECTED": "getrennt",
                "DELETED": "gelöscht",
                "EXPIRED": "abgelaufen",
                "WAITING": "wartend",
                "FAILED": "gescheitert",
                "DOWNLOAD": "Herunterladen",
                "PLAY": "Abspielen",
                "TRANSCRIBE": "Transkribieren",
                "TRANSCRIBING": "Wird transkribiert",
                "VIEW_TRANSCRIPT": "Transkript",
                "RETRY_TRANSCRIPTION": "Transkription erneut versuchen",
                "TRANSCRIPTION": "Transkription",
                "TRANSCRIPTION_FAILED": "Transkription fehlgeschlagen",
                "NO_TRANSCRIPT": "In dieser Aufzeichnung wurde keine Sprache erkannt.",
                "NO_TRANSCRIPT_HINT": "Die Aufzeichnung wurde erfolgreich verarbeitet, enthält aber keinen gesprochenen Inhalt zur Anzeige.",
                "LANGUAGE": "Sprache",
                "FULL_TEXT": "Volltext",
                "SPEAKERS": "Sprecher",
                "SEGMENTS": "Segmente",
                "DELETE": "Löschen",
                "GENERATING": "Wird generiert...",
                "PLEASE_WAIT": "Bitte warten...",
                "WEBDAV": "WEBDAV",
                "DOWNLOAD_ARCHIVE": {
                    "TITLE": "Aufzeichnung herunterladen",
                    "GENERATING": "Download-URL erstellen",
                    "GENERATED": "Die Download-URL wurde erstellt.",
                    "CANNOT_GENERATED": "Die Download-URL konnte nicht erstellt werden.",
                    "DOWNLOAD": "Herunterladen",
                     "CLOSE": "Schließen"
                },
                "DELETE_ARCHIVE": {
                    "TITLE": "Aufzeichnung löschen",
                    "MESSAGE": "Die Aufzeichnung des Videoanrufs wird gelöscht.",
                    "CAUTION": "ACHTUNG: Diese Aufzeichnung wird auch auf Ihrem Azure Cloud-Speicher gelöscht.",
                    "CANCEL": "Abbrechen",
                    "DELETE": "Löschen"
                }
            }
        },
        "ROOMS": {
            "ROOM_DETAILS": {
                "BACK": "Zurück",
                "TITLE_NEW": "Neue Arbeitsgruppe",
                "TITLE_DETAILS": "Arbeitsgruppendetails",
                "TITLE_EDIT": "Arbeitsgruppe bearbeiten",
                "ROOM_DISABLED": "ARBEITSGRUPPE DEAKTIVIERT",
                "EDIT": "Bearbeiten",
                "RESET": "Zurücksetzen",
                "REVERT": "Umkehren",
                "CANCEL": "Abbrechen",
                "ICON": "Symbol",
                "CHOOSE_FILE": "Datei auswählen...",
                "ROOM_NAME": "Arbeitsgruppe",
                "TECHNICAL_DRAWING": "Technische Zeichnung",
                "HAND_TOOLS": "Werkzeuge",
                "FINISHED_PRODUCT": "Fertiges Produkt",
                "VIDEO": "Video",
                "ROOM_NAME_REQUIRED": "Name erforderlich",
                "ROOM_NAME_LENGTH": "Der Name muss zwischen 1-60 Zeichen enthalten",
                "DESCRIPTION": "Beschreibung",
                "DESCRIPTION_REQUIRED": "Beschreibung erforderlich",
                "DESCRIPTION_LENGTH": "Die Beschreibung muss zwischen 1-100 Zeichen enthalten",
                "USERS": "User",
                "SELECT_USERS": "User auswählen",
                "SAVE": "SPEICHERN",
                "ROOM_UPDATED": "Die Arbeitsgruppe wurde erfolgreich geändert.",
                "CANNOT_UPDATE": "Die Arbeitsgruppe konnte nicht geändert werden.",
                "ROOM_CREATED": "Die Arbeitsgruppe wurde erstellt.",
                "CANNOT_CREATE": "Die Arbeitsgruppe konnte nicht erstellt werden.",
                "ALWAYS_ARCHIVE_ON": "Alle Arbeitsgruppen werden automatisch in Ihrem Konto aufgezeichnet. Sie können dies in den Einstellungen ändern.",
                "ARCHIVE_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Videoanrufe aufzuzeichnen' nicht.",
                "PEER_TO_PEER_NO_ARCHIVE": "Aufzeichnung für Peer-to-Peer-Videoanrufe nicht verfügbar. Bitte wenden Sie sich an Ihren Administrator.",
                "AUTO_ARCHIVE": "Videoanrufe in dieser Arbeitsgruppe automatisch aufzeichnen",
                "ARCHIVE_PERMISSION_NEEDED": "Die Zustimmung aller User für die Aufzeichnung einholen.",
                "PEER_TO_PEER": "Videoanrufe Peer-to-Peer durchführen",
                "WHAT_IS_PEER_TO_PEER": "(Was bedeutet P2P)",
                "PEER_TO_PEER_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Peer-to-Peer' nicht.",
                "FULL_HD": "Auf unterstützten mobilen Endgeräten Stream- und Schnappschuss in FullHD Qualität",
                "FULL_HD_DISADVANTAGES": "Bitte verwenden Sie diese Option, wenn die Internetverbindung der Teilnehmer stabil ist. Beachten Sie, dass dies auf mobilen Geräten zu erhöhtem Energie- und Datenverbrauch, sowie zu Verbindungsproblemen führen kann.",
                "ALWAYS_FULL_HD_ON": "Der Stream- und Schnappschuss für Mobilgeräte für alle Arbeitsgruppen ist FullHd. Sie können dies in den Einstellungen ändern.",
                "FULL_HD_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Full HD' nicht.",
                "TRAINING_ROOM_NO_PEER_TO_PEER": "Peer-to-Peer ist für Schulungsräume nicht verfügbar.",
                "TRAINING_ROOM": "Schulungsraum",
                "TRAINING_LICENSE": "Lizenz für Schulungsräume",
                "TRAINING_LICENSE_REQUIRED": "Sie benötigen eine Lizenz für Schulungsräume.",
                "TRAINING_MASTER": "Host des Schulungsraums",
                "TRAINING_MASTER_REQUIRED": "Es wird ein Host für den Schulungsraum benötigt.",
                "TRAINING_ROOM_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Schulungsraum' nicht.",
                "WHAT_IS_P2P": {
                    "TITLE": "Was bedeutet Peer-to-Peer",
                    "BETWEEN_CLIENTS": "Der Audio-Video Stream wird direkt zwischen den Clients aufgebaut.",
                    "REDUCED_LATENCY": "Die Peer-to-Peer Option ermöglicht die Reduktion von Latenzen.",
                    "ARCHIVE_UNAVAILABLE": "Peer-to-Peer Sessions können nicht aufgezeichnet werden, da eine direkte Verbindung zwischen den beteiligten Peers hergestellt wird.",
                    "CLOSE": "Schließen"
                },
                "ENABLE_ROOM": "ARBEITSGRUPPE AKTIVIEREN",
                "DISABLE_ROOM": "ARBEITSGRUPPE DEAKTIVIEREN",
                "TOGGLE_ROOM_MODAL": {
                    "TITLE_ENABLE": "Arbeitsgruppe aktivieren?",
                    "TITLE_DISABLE": "Arbeitsgruppe deaktivieren?",
                    "MESSAGE_ENABLE": "Sind Sie sicher, dass die Arbeitsgruppe <strong>{{name}}</strong> aktiviert werden soll?",
                    "MESSAGE_DISABLE": "Sind Sie sicher, dass die Arbeitsgruppe <strong>{{name}}</strong> deaktiviert werden soll?",
                    "CANCEL": "Abbrechen",
                    "ENABLE": "Aktivieren",
                    "DISABLE": "Deaktivieren",
                    "ENABLED": "Die Arbeitsgruppe wurde aktiviert.",
                    "DISABLED": "Die Arbeitsgruppe wurde deaktiviert.",
                    "ERROR": "Die Arbeitsgruppe konnte nicht bearbeitet werden."
                },
                "DELETE_ROOM": "ARBEITSGRUPPE LÖSCHEN",
                "DELETE_ROOM_MODAL": {
                    "TITLE": "Arbeitsgruppe löschen?",
                    "MESSAGE": "Soll die Arbeitsgruppe <strong>{{name}}</strong> gelöscht werden?",
                    "CANCEL": "Abbrechen",
                    "DELETE": "Löschen",
                    "DELETED": "Die Arbeitsgruppe wurde gelöscht.",
                    "ERROR": "Die Arbeitsgruppe konnte nicht gelöscht werden."
                },
                "CHANGE_AUTO_ARCHIVE_MODAL": {
                    "TITLE": "Änderungen speichern",
                    "MESSAGE_START": "Änderungen an ",
                    "AUTO_ARCHIVE": "der automatischen Aufzeichnung von Videoanrufen",
                    "AND": " und ",
                    "PEER_TO_PEER": "Peer-to-Peer",
                    "MESSAGE_END": " werden bei allen künftigen Sessions wirksam.",
                    "CAUTION": "ACHTUNG: Die Session kann nicht aufgezeichnet werden, solange Peer-to-Peer aktiviert ist.",
                    "TRAINING_CAUTION": "Sobald dieser Raum in einen Schulungsraum umgewandelt wird (oder umgekehrt), wird diese Session automatisch für alle beendet.",
                    "CANCEL": "Abbrechen",
                    "SAVE": "Speichern"
                },
                "CREATE_WORK_GROUP": "Arbeitsgruppe erstellen",
                "EDIT_WORK_GROUP_DETAILS": "Arbeitsgruppen-Details bearbeiten",
                "ENABLE_WORK_GROUP": "Arbeitsgruppe aktivieren",
                "DISABLE_WORK_GROUP": "Arbeitsgruppe deaktivieren", 
                "DELETE_WORK_GROUP": "Arbeitsgruppe löschen",
                "UPLOAD_IMAGE": "Bild hochladen"
            },
            "ROOM_LIST": {
                "TITLE": "Arbeitsgruppen",
                "NO_ROOM_MESSAGE": "Die Liste aller Arbeitsgruppen ist leer",
                "NEW_ROOM": "Neue Arbeitsgruppe",
                "ICON": "Symbol",
                "ROOM_NAME": "Arbeitsgruppe",
                "DISABLED": "Deaktiviert",
                "USERS": "User",
                "ACTIVE": "Aktiv",
                "PASSIVE": "Passiv",
                "DETAILS": "Details",
                "EDIT": "Bearbeiten",
                "DELETE": "Löschen",
                "DISABLE": "Deaktivieren",
                "ENABLE": "Aktivieren",
                "ROOM_LIMIT_REACHED": "Die maximale Anzahl an {{ appName }} Arbeitsgruppen wurde erreicht.",
                "GUEST": "Gast",
                "ALL_USERS": "Alle User"
            }
        },
        "SESSIONS": {
            "SESSION_DETAILS": {
                "TITLE": "Sessiondetails",
                "BACK": "Zurück",
                "WIPE_SESSION_DATA": "Sitzungsdaten löschen",
                "SESSION_DATA_WIPED": "Sitzungsdaten wurden bereits gelöscht",
                "PARTICIPANTS": "Teilnehmer",
                "CREATED_AT": "Erstellt am: ",
                "DURATION": "Dauer: ",
                "GUEST": "(Gast)",
                "ATTACHED_TICKET": "Verknüpftes Ticket",
                "ATTACH_TO_TICKET": "Mit Ticket verknüpfen",
                "CHANGE_TICKET": "Ticket ändern",
                "ATTACH_SESSION_TO_TICKET": "Session an Ticket anhängen",
                "CLOSE": "Schließen",
                "ATTACH": "Anhängen",
                "APPLY_FILTERS": "Filter anwenden",
                "SESSIONS": "Sessions",
                "SESSION_COUNT": "Anzahl Sessions",
                "TOTAL_DURATION": "Gesamtdauer",
                "EXPORT": "Liste exportieren",
                "GET_SESSION_EXPORT": "Session-Export abrufen",
                "DATE": "Datum",
                "USER_ROLES": {
                    "UNKNOWN": "Unbekannt",
                    "ADMIN": "Administrator",
                    "CO_ADMIN": "Co-Administrator",
                    "EXPERT": "Experte",
                    "USER": "User",
                    "SUBSCRIBER": "Subscriber"
                },
                "SESSION_EXPORT": {
                    "TITLE": "Sessionexport",
                    "MESSAGE": "Der Sessionexport umfasst alle Chat-Nachrichten, Snapshots, Videoanrufaufzeichnungen und Dateien, die in der Session freigegeben wurden.",
                    "SEND": "Senden",
                    "EXPORT_SUCCEEDED": "Der Sessionexport wird nach Beenden der Session gesendet.",
                    "EXPORT_FAILED": "Ein Fehler ist aufgetreten.",
                    "WARNING": "Bitte drücken Sie nach jeder E-Mail-Adresse die Eingabetaste."
                },
                "WIPE_SESSION_DATA_MODAL": {
                    "TITLE": "Sitzungsdaten löschen?",
                    "MESSAGE": "Sind Sie sicher, dass Sie die Sitzungsdaten löschen möchten? Schnappschüsse, Videoaufzeichnungen und geteilte Dateien werden gelöscht.",
                    "WARNING": "Dieser Vorgang kann nicht rückgängig gemacht werden.",
                    "CLOSE": "Schließen",
                    "WIPE": "Löschen",
                    "WIPE_SUCCEEDED": "Sitzungsdaten wurden gelöscht.",
                    "WIPE_FAILED": "Ein Fehler ist aufgetreten."
                },
                "SESSION_CHAT" : {
                    "COLLABORATE": "Zusammenarbeiten",
                    "CLOSE_COLLABORATION": "Zusammenarbeit schließen",
                    "DOWNLOAD": "Download",
                    "DELETE": "Löschen",
                    "DETAILS": "Details",
                    "FILE_DELETED": "Datei gelöscht",
                    "JOIN_ROOM" : "{{ owner_info }} ist der Session beigetreten",
                    "LEAVE_ROOM" : "{{ owner_info }} hat die Session verlassen",
                    "REACTION": "{{ owner_info }} hat eine Reaktion gesendet",
                    "REQUEST_SCREENSHOT": "{{ owner_info }} hat einen Schnappschuss erstellt",
                    "SHARE_SCREENSHOT" : "{{ owner_info }} hat eine Schnappschuss geteilt",
                    "SHARE_IMAGE" : "{{ owner_info }} hat ein Bild geteilt",
                    "SHARE_PDF" : "{{ owner_info }} hat ein PDF geteilt",
                    "SHARE_OTHER" : "{{ owner_info }} hat eine Datei geteilt",
                    "SHARE_OBJECT" : "{{ owner_info }} hat ein 3D-Objekt geteilt",
                    "COLLABORATED" : "{{ owner_info }} hat die Zusammenarbeit begonnen"
                },
                "FILES": "Dateien",
                "CHAT": "Chat"
            },
            "SESSION_LIST": {
                "ALL_SESSIONS": "Alle Sessions",
                "LAST_SESSIONS": "Letzte Sessions",
                "ROOM_SESSIONS": "Die letzten 3 Sessions in {{room}}",
                "LOADING": "Wird geladen",
                "NO_SESSION_MESSAGE": "Die Liste aller Sessions ist leer.",
                "DATE": "Datum",
                "ROOM_NAME": "Arbeitsgruppe",
                "PARTICIPANTS": "Teilnehmer",
                "STATUS": "Status",
                "DURATION": "Dauer",
                "GUEST": "(Gast)",
                "ON_GOING": "Laufend",
                "ENDED": "Beendet",
                "START_END": "Anfang Ende",
                "ALL_ROOMS": "Alle Arbeitsgruppen",
                "ALL_USERS": "Alle User",
                "ALL_LABELS": "Alle Labels",
                "CSV": "CSV",
                "EXPORT_HEADER": "Erstellt am,Arbeitsgruppe,Dauer (min),Teilnehmer",
                "UNKNOWN": "Unbekannt",
                "GUEST_LABEL": " (Gast)",
                "MORE": "mehr"
            },
            "SESSION_FILES": {
                "DOWNLOAD_STARTED_SOON": "Der Download wird in Kürze gestartet.",
                "DOWNLOAD_FAILED": "Download fehlgeschlagen",
                "NO_FILE_IS_ADDED": "In dieser Session wurden keine Dateien hinzugefügt oder bearbeitet.",
                "FILE_NAME": "Dateiname:",
                "FILE_CONTENTS": "Dateiinhalte:",
                "FILE_SIZE": "Dateigröße:",
                "ESTIMATED_FILE_SIZE": "Geschätzte Größe:",
                "APPROX_EXPORT_PDF_SIZE": "Ca. 60 KB"
            }
        },
        "USERS": {
            "USER_DETAILS": {
                "BACK": "Zurück",
                "TITLE_NEW": "Neuer User",
                "TITLE_DETAILS": "Userdetails",
                "TITLE_EDIT": "User bearbeiten",
                "USER_DISABLED": "USER DEAKTIVIEREN",
                "EDIT": "Bearbeiten",
                "RESET": "Zurücksetzen",
                "REVERT": "Umkehren",
                "CANCEL": "Abbrechen",
                "USER_ROLE": "Rolle",
                "ADMIN": "Admin",
                "COADMIN": "Co-Admin",
                "USER": "User",
                "SUBSCRIBER": "Subscriber",
                "EXPERT": "Experte",
                "NAME": "Name",
                "ROLE": "Rolle",
                "PERMISSIONS": "Berechtigungen",
                "CLOSE": "Schließen",
                "REACHED_MAX_NUMBER_EXPERT_LIMIT": "Die maximale Anzahl an Experten wurde erreicht.",
                "SINGLE_SIGN_ON_CODE": "Einmaliger Anmeldungscode",
                "GENERATING": "Erstellen",
                "GENERATE_CODE": "Code erstellen",
                "CLICK_CODE_FOR_COPY": "zum kopieren auf den Code klicken",
                "ARCHIVE_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Videoanrufe aufzeichnen' nicht.",
                "ALLOW_ARCHIVING": "Berechtigung die Aufzeichnungen von Videoanrufen zu starten/stoppen.",
                "PERSONAL_ROOM_SETTINGS": "Individuelle Arbeitsgruppen Einstellungen (Anruffunktion)",
                "CALL_ARCHIVE_PERM_NEEDED": "Die Zustimmung aller User wird benötigt, um die Aufnahme zu starten.",
                "CALLING_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Anruf' nicht.",
                "ALLOW_CALLING": "Berechtigung Anrufe durchzuführen",
                "ALLOW_SEEING_ALL_USERS": "Berechtigung die Liste aller User einzusehen",
                "JOIN_LINK_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Gastzugang' nicht.",
                "ALLOW_JOIN_LINK": "Berechtigung einen \"Gastzugang\" zu erstellen",
                "PERMISSION_TO_SEE_USERS_IN_SAME_ROOM": "Berechtigung, die anderen User in der Arbeitsgruppe zu sehen",
                "PERMISSION_TO_SEE_USERS_ALL": "Berechtigung, alle User zu sehen",
                "NAME_REQUIRED": "Name erforderlich",
                "NAME_START_WITH": "Der Name muss alphanumerisch beginnen.",
                "NAME_CONTAINS": "Der Name kann alphanumerische Zeichen, die Sonderzeichen -._ und Leerzeichen enthalten.",
                "NAME_LENGTH": "Der Name muss zwischen 1-60 Zeichen enthalten.",
                "USERNAME": "Username",
                "USERNAME_REQUIRED": "Username erforderlich",
                "USERNAME_ALREADY_TAKEN": "Bereits vergeben",
                "USERNAME_CONTAINS": "Wählen Sie einen Usernamen, der ausschließlich alphanumerische Zeichen, Unterstriche ( _ ) bzw. Bindestriche ( - )beinhaltet.",
                "USERNAME_LENGTH": "Der Username muss zwischen 1-30 Zeichen enthalten.",
                "EMAIL": "Email",
                "EMAIL_REQUIRED": "Email erforderlich, wenn die Zwei-Faktor-Authentifizierung aktiviert ist",
                "EMAIL_INVALID": "Ungültige Email-Adresse",
                "PASSWORD": "Passwort",
                "PASSWORD_REQUIRED": "Passwort erforderlich",
                "PASSWORD_MINLENGTH": "Das Passwort muss zwischen 6-30 Zeichen enthalten.",
                "CONFIRM_PASSWORD": "Passwort bestätigen",
                "CONFIRM_PASSWORD_NOTMATCH": "Die Passwörter stimmen nicht überein.",
                "DEFAULT_ROOM": "Standard-Arbeitsgruppe",
                "ROOMS": "Arbeitsgruppen",
                "WORK_GROUP_SETTINGS": "Arbeitsgruppen-Einstellungen",
                "SELECT_ROOMS": "Arbeitsgruppen auswählen",
                "SAVE": "SPEICHERN",
                "CALL_INFO_MODAL": {
                    "TITLE": "Berechtigung Anrufe durchzuführen?",
                    "MESSAGE": "User mit der Berechtigung Anrufe durchzuführen können auf die Userliste zugreifen und Anrufe tätigen, ohne zuvor eine Arbeitsgruppe erstellt zu haben.",
                    "CLOSE": "Schließen"
                },
                "QR_CODE_TITLE": "QR-Code",
                "QR_CODE_LOADING": "QR-Code wird geladen",
                "QR_ENABLE_FIRST": "User deaktiviert",
                "NO_QR_CODE": "Kein QR-Code vorhanden",
                "GENERATE_QR": "QR-Code erstellen",
                "QR_MESSAGE": "Mit diesem QR-Code können Sie Videobrillen, Tablets und Mobiltelefone authentifizieren.",
                "REGENERATE": "Neu erstellen",
                "REMOVE": "Löschen",
                "DOWNLOAD": "Download",
                "CHANGE_PASSWORD_TITLE": "Passwort ändern",
                "CHANGE_PASSWORD": "PASSWORT ÄNDERN",
                "CREATE_NEW_PASSWORD": "Passwortanforderungen",
                "UPPERCASE": "Großbuchstaben",
                "LOWERCASE": "Kleinbuchstaben",
                "NUMBER": "Zahl",
                "SPECIAL": "Sonderzeichen",
                "NOT_WHITESPACE": "Das Passwort darf keine Leerzeichen enthalten",
                "AT_LEAST_PASSWORD_LENGTH": "Mindestens {{ passwordlength }} Zeichen",
                "DO_NOT_CREATE_SIMPLE": "Vermeiden Sie schwache Passwörter wie z.B. Passwort oder '123456'",
                "CHANGE_PASSWORD_MODAL": {
                    "TITLE": "Passwort ändern?",
                    "MESSAGE": "Das Userpasswort wird geändert.",
                    "CAUTION": "ACHTUNG: Bitte beachten Sie, dass der aktuelle User Qr-Code gelöscht wird.",
                    "CANCEL": "Abbrechen",
                    "CHANGE": "Ändern"
                },
                "PASSWORD_CHANGED": "Das Passwort wurde geändert.",
                "CANNOT_CHANGE": "Das Passwort konnte nicht geändert werden.",
                "QR_REMOVE_TITLE": "QR-Code löschen?",
                "QR_REMOVE_MESSAGE": "Der QR-Code wird gelöscht.",
                "QR_REMOVE_NO": "Abbrechen",
                "QR_REMOVE_YES": "Löschen",
                "QR_REGENERATE_TITLE": "Neu erstellen?",
                "QR_REGENERATE_MESSAGE": "Der vorherige QR-Code wird deaktiviert.",
                "QR_REGENERATE_NO": "Abbrechen",
                "QR_REGENERATE_YES": "Neu erstellen",
                "QR_REMOVED": "Der QR-Code wurde gelöscht.",
                "CANNOT_REMOVE": "Der QR-Code konnte nicht gelöscht werden.",
                "QR_GENERATED": "Der QR-Code wurde erstellt.",
                "CANNOT_GENERATE": "Der QR-Code konnte nicht erstellt werden.",
                "USER_UPDATED": "Die User wurden erfolgreich aktualisiert.",
                "CANNOT_UPDATE": "Die User konnten nicht aktualisiert werden.",
                "USER_CREATED": "Der User wurde erstellt.",
                "CANNOT_CREATE": "Der User konnte nicht erstellt werden.",
                "UPDATE_USER_MODAL": {
                    "TITLE": "Änderungen übernehmen?",
                    "USENAME_MESSAGE": "Der Username wird geändert.",
                    "USENAME_CAUTION": "ACHTUNG: Bitte beachten Sie, dass der aktuelle User-QR-Code gelöscht wird.",
                    "EMAIL_MESSAGE": "Die Admin Email-Adresse wird gelöscht.",
                    "EMAIL_CAUTION": "ACHTUNG: Sie erhalten keine wöchentlichen Nutzungsberichte mehr. Weitere Empfänger werden ebenfalls entfernt.",
                    "CANCEL": "Abbrechen",
                    "CHANGE": "Ändern"
                },
                "WITHOUT_ROOM_MODAL": {
                    "TITLE": "Soll der User ohne Arbeitsgruppezuordnung angelegt werden?",
                    "MESSAGE": "Der User wird ohne Arbeitsgruppezuordnung angelegt.",
                    "CANCEL": "Abbrechen",
                    "CREATE": "Erstellen"
                },
                "DISABLE_USER": "USER DEAKTIVIEREN",
                "ENABLE_USER": "USER AKTIVIEREN",
                "TOGGLE_USER_MODAL": {
                    "TITLE_ENABLE": "User aktivieren?",
                    "TITLE_DISABLE": "User deaktivieren?",
                    "MESSAGE_ENABLE": "Sind Sie sicher, dass der User <strong>{{name}}</strong> aktiviert werden soll?",
                    "MESSAGE_DISABLE": "Sind Sie sicher, dass der User <strong>{{name}}</strong> deaktiviert werden soll?",
                    "CANCEL": "Abbrechen",
                    "ENABLE": "Aktivieren",
                    "DISABLE": "Deaktivieren",
                    "ENABLED": "Der User wurde aktiviert.",
                    "DISABLED": "Der User wurde deaktiviert.",
                    "ERROR": "Der Status des Users konnte nicht geändert werden."
                },
                "DELETE_USER": "USER LÖSCHEN",
                "DELETE_USER_MODAL": {
                    "TITLE": "User löschen?",
                    "MESSAGE": "Sind Sie sicher, dass der User <strong>{{name}}</strong> gelöscht werden soll?",
                    "CAUTION": "ACHTUNG: Dieser Schritt kann nicht rückgängig gemacht werden!",
                    "CANCEL": "Abbrechen",
                    "DELETE": "Löschen",
                    "DELETED": "Der User wurde gelöscht.",
                    "ERROR": "Der User konnte nicht gelöscht werden."
                },
                "LABEL": "Label",
                "CREATE_NEW_LABELS": "Neu erstellen"
            },
            "ALL_ROOMS": "Alle Arbeitsgruppen",
            "ALL_ROLES": "Alle Rollen",
            "NAME_USERNAME": "Name oder Username"
        },
        "ANALYTICS": {
            "TITLE": "Organisations-Analytik",
            "DASHBOARD": "Dashboard",
            "USAGE": "Nutzung",
            "TOTAL_COMPLETIONS": "Gesamteinreichungen",
            "ACTIVE_DOMAINS": "Aktive Domains",
            "SHARED_WORKFLOWS": "Geteilte Workflows",
            "COMPLETIONS_BY_DOMAIN": "Nach Domain",
            "COMPLETIONS_BY_WORKFLOW": "Nach Workflow",
            "NOT_AVAILABLE": "Analytik ist nur für Hauptkonten verfügbar.",
            "START_DATE": "Startdatum",
            "END_DATE": "Enddatum",
            "DOMAIN": "Nach Domain",
            "WORKFLOW": "Nach Workflow",
            "COMPLETIONS": "Abschlüsse",
            "TOTAL_WORKFLOWS": "Gesamte Workflows",
            "TOTAL_SHARED_WORKFLOWS": "Gesamte Geteilte Workflows",
            "TOTAL_USERS": "Gesamte Benutzer",
            "TOTAL_SUBMISSIONS": "Gesamte Einreichungen",
            "CHILD_ACCOUNTS_BREAKDOWN": "Unterkonten-Übersicht",
            "ACCOUNT": "Konto",
            "WORKFLOWS": "Workflows",
            "SHARED": "Geteilt",
            "USERS": "Benutzer",
            "SUBMISSIONS": "Einreichungen"
        },
        "SETTINGS": {
            "TABS": {
                "GENERAL": "Allgemein",
                "INTEGRATIONS": "Integrationen",
                "LICENSE": "Lizenz",
                "TICKET": "Ticket"
            },
            "ARCHIVE": {
                "TITLE": "Einstellungen für die Aufzeichnung von Videoanrufen",
                "ROOMS": "Arbeitsgruppen",
                "RECORD_STATUS": "Status der Aufzeichnung",
                "AUTO": "Auto",
                "P2P": "P2P",
                "MANUAL": "Manuell",
                "AUTO_RECORD": "Automatisch alle Arbeitsgruppen aufzeichnen",
                "CHANGE_INDIVIDUALLY": "Sie können die Aufzeichnungseinstellungen in den Einstellungen der einzelnen Arbeitsgruppen ändern.",
                "NO_ARCHIVE": "Ihre Lizenz enthält die Funktion 'Videoanruf aufzeichnen' nicht.",
                "SAVE": "SPEICHERN"
            },
            "ALWAYS_FULL_HD": {
                "TITLE": "Stream-/Schnappschuss-Qualität für mobile Geräte (einschließlich Meetings und Anrufe)",
                "FULL_HD_MESSAGE": "Erstellen Sie auf unterstützten Mobilgeräten Stream-/Schnappschuss-Qualität in FullHD",
                "INDIVIDUAL_MESSAGE": "Sie können das Verhalten der Stream-/Schnappschuss-Qualität auf Arbeitsgruppen- und Benutzerseiten (für Anrufe) individuell ändern",
                "CANCEL": "Abbrechen",
                "PROCEED": "Fortfahren",
                "CHANGE": "Individuell ändern",
                "SAVE": "SPEICHERN"
            },
            "FULL_HD_MODAL": {
                "FULL_HD": "Machen Sie Stream-/Schnappschuss-Qualität in FullHD",
                "CHANGE_INDIVIDUALLY": "Ändern Sie das Verhalten der Stream-/Schnappschuss-Qualität individuell",
                "FULL_HD_MESSAGE": "Die Stream-/Schnappschuss ist auf unterstützten Mobilgeräten FullHD.",
                "INDIVIDUAL_MESSAGE": "Sie können das Verhalten der Stream-/Schnappschuss-Qualität auf Arbeitsgruppen- und Benutzerseiten (für Anrufe) individuell ändern.",
                "WARNING": "Änderungen der Stream-/Schnappschuss-Qualität werden auf nachfolgende Sitzungen angewendet.",
                "CANCEL": "Abbrechen",
                "PROCEED": "Fortfahren",
                "CHANGE": "Individuell ändern"
            },
            "EMAIL_RECIPIENTS": {
                "TITLE": "Empfängerliste des wöchentlichen Nutzungsberichts",
                "MESSAGE": "Sie können weitere Email-Adressen zur Empfängerliste des wöchentlichen Nutzungsberichts von {{ appName }} hinzufügen.",
                "PLACEHOLDER": "Neu hinzufügen",
                "SECONDARY_PLACEHOLDER": "Email-Adresse eingeben",
                "ADMIN_MAIL_FIRST": "Bitte fügen Sie zuerst die Admin Email-Adresse aus dem Usermenü hinzu.",
                "INVALID_EMAIL": "Ungültige Email-Adresse",
                "SAVE": "SPEICHERN",
                "CANNOT_CHANGE": "Die Empfängerliste konnte nicht aktualisiert werden.",
                "WARNING": "Bitte drücken Sie nach jeder E-Mail-Adresse die Eingabetaste."
            },
            "TWO_FACTOR_AUTH": {
                "TITLE": "Zweistufiger Verifizierungscode",
                "ADMIN_2FA": "Zwei-Faktor-Authentifizierung des Admin Panels",
                "EXPERT_2FA": "Experten-Zwei-Faktor-Authentifizierung",
                "CAUTION": "Sie müssen die Admin-Zwei-Faktor-Authentifizierung aktivieren, bevor Sie sie für Experten aktivieren können.",
                "ENABLE": "Aktivieren",
                "DISABLE": "Deaktivieren",
                "TWO_FACTOR_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Zwei-Faktor-Authentifizierung' nicht.",
                "TWO_FACTOR_ENABLED": "Zwei-Faktor-Authentifizierung aktiviert",
                "TWO_FACTOR_DISABLED": "Zwei-Faktor-Authentifizierung deaktiviert"
            },
            "TIMEZONE": {
                "TITLE": "Zeitzone ändern",
                "SAVE": "SPEICHERN",
                "CANNOT_CHANGE": "Die Zeitzone konnte nicht geändert werden."
            },
            "DEFAULT_WORK_GROUPS": {
                "TITLE": "Standard-Arbeitsgruppen",
                "MESSAGE": "Wählen Sie die Arbeitsgruppen aus, denen neue Benutzer standardmäßig zugewiesen werden.",
                "SELECT": "Arbeitsgruppen auswählen",
                "NO_WORK_GROUP": "In diesem Konto gibt es noch keine Arbeitsgruppe.",
                "SAVE": "SPEICHERN",
                "SAVED": "Standard-Arbeitsgruppen wurden aktualisiert.",
                "CANNOT_CHANGE": "Die Standard-Arbeitsgruppen konnten nicht geändert werden.",
                "STALE_SELECTION": "Eine der ausgewählten Arbeitsgruppen ist nicht mehr vorhanden. Laden Sie die Seite neu und versuchen Sie es erneut."
            },
            "VOICE_COMMANDS": {
                "TITLE": "Sprachbefehle",
                "NEW_COMMAND": "Neuer Befehl",
                "LOADING": "Wird geladen",
                "NO_COMMAND": "Die Liste aller Befehle ist leer",
                "COMMAND": "Befehl",
                "TRANSLATION": "Übersetzung",
                "LANGUAGE": "Sprache",
                "UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Sprachbefehle' nicht.",
                "ADD_MODAL": {
                    "TITLE": "Neuen Befehl hinzufügen",
                    "CLOSE": "Schließen",
                    "ADD": "Hinzufügen"
                }
            },
            "AZURE_AD": {
                "CANCEL": "Abbrechen",
                "ADD": "Hinzufügen",
                "REMOVE": "Entfernen",
                "COPY": "Kopieren",
                "AZURE_AD_INTEGRATION": "AZURE AD INTEGRATION",
                "SINGLE_SIGN_ON": "Einmalige Anmeldung",
                "CONFIGURE_SAML": "Hier können Sie die SAML-basierte einmalige Anmeldungen konfigurieren.",
                "ADD_SAML_CONFIGURATION": "SAML-Konfiguration hinzufügen",
                "REMOVE_SAML_CONFIGURATION": "SAML-Konfiguration entfernen",
                "INFORMATION": "Von Azure Active Directory benötigte Informationen",
                "INFORMATION_VSIGHT": "Von VSight benötigte Informationen",
                "IDENTIFIER": "Identifier (Entity ID)",
                "REPLY_URL": "Antwort-URL",
                "REPLY_URL2": "Antwort-URL2",
                "REPLY_URL3": "Antwort-URL3",
                "USER_PROVISIONING": "User Bereitstellung",
                "SCIM_USER_PROVISIONING": "Hier können Sie die SCIM-basierte User Bereitstellung konfigurieren.",
                "ADD_SCIM_CONFIGURATION": "SCIM-Konfiguration hinzufügen",
                "REMOVE_SCIM_CONFIGURATION": "SCIM-Konfiguration entfernen",
                "INFO": "Von Azure Active Directory benötigte Informationen",
                "ENDPOINT": "SCIM Endpoint (Tenant URL)",
                "ADD_SAML": "SAML-Konfiguration hinzufügen",
                "SSO": "Identitätsprovider SSO URL",
                "SSO_URL_REQUIRED": "SSO URL erforderlich",
                "CERTIFICATE": "Öffentliches x509 Zertifikat",
                "CERTIFICATE_REQUIED": "Zertifikat erforderlich",
                "GENERATE_TOKEN_FOR_SCIM": "Token für SCIM generieren",
                "REMOVE_SAML_CONFIGURATION_QUESTION": "Sind Sie sicher, dass Sie die SAML-Konfiguration entfernen möchten?",
                "REMOVE_SCIM_CONFIGURATION_QUESTION": "Sind Sie sicher, dass Sie die SCIM-Konfiguration entfernen möchten?"
            },
            "OAUTH_OIDC": {
                "OAUTH_OIDC_TITLE": "OAUTH OIDC KONFIGURATION",
                "OAUTH_OIDC": "OAUTH OpenID Connect",
                "CONFIGURE_OAUTH_OIDC": "Hier können Sie OAUTH OpenID Connect konfigurieren.",
                "ADD_OAUTH_OIDC_CONFIGURATION": "OIDC-Konfiguration hinzufügen",
                "REMOVE_OAUTH_OIDC_CONFIGURATION": "OIDC-Konfiguration entfernen",
                "INFORMATION": "Details",
                "INITIATE_LOGIN_URL": "Login-URL initiieren",
                "REDIRECT_URL": "Weiterleitungs-URL",
                "COPY": "Kopieren",
                "ADD_OIDC": "OIDC-Konfiguration hinzufügen",
                "INFORMATION_VSIGHT": "Von VSight benötigte Informationen",
                "DISCOVERY_ENDPOINT": "Discovery-Endpunkt",
                "DISCOVERY_ENDPOINT_REQUIRED": "Discovery-Endpunkt erforderlich.",
                "CLIENT_ID": "Client-ID",
                "CLIENT_ID_REQUIRED": "Client-ID erforderlich.",
                "CLIENT_SECRET": "Client-Secret",
                "CLIENT_SECRET_REQUIRED": "Client-Secret erforderlich.",
                "RESPONSE_TYPE": "Antworttyp",
                "RESPONSE_TYPE_CODE": "code",
                "LOGOUT_URL": "Logout-URL",
                "REMOVE_OIDC_CONFIGURATION": "OIDC-Konfiguration entfernen",
                "REMOVE_OIDC_CONFIGURATION_QUESTION": "Sind Sie sicher, dass Sie die OIDC-Konfiguration entfernen möchten?",
                "CANCEL": "Abbrechen",
                "ADD": "Hinzufügen",
                "REMOVE": "Entfernen"
            },
            "ENABLE_SYSTEM_EMAIL": {
                "CONFIGURE_CUSTOM_SERVICE_EMAIL": "Benutzerdefinierte Service-Email konfigurieren",
                "SENDER_NAME": "Absender",
                "SENDER_NAME_IS_REQUIRED": "Absender erforderlich",
                "SENDER_HOST": "Absender-Host",
                "SENDER_HOST_IS_REQUIRED": "Absender-Host erforderlich",
                "SENDER_PORT": "Absender-Port",
                "SENDER_EMAIL": "Absender-EMail",
                "SENDER_EMAIL_IS_REQUIRED": "Absender-E-Mail erforderlich.",
                "USER": "User",
                "USER_IS_REQUIRED": "User erforderlich",
                "EMAIL_FORMAT_IS_INVALID": "Ungültige Email-Adresse",
                "PASSWORD": "Passwort",
                "PASSWORD_IS_REQUIRED": "Passwort erforderlich",
                "CANCEL": "Abbrechen",
                "VERIFY": "Bestätigen",
                "VERIFY_CUSTOM_SERVICE_EMAIL": "Benutzerdefinierte Service-Email bestätigen",
                "SEND_VERIFICATION_CODE": "Wir haben Ihnen eine E-Mail mit einem Verifizierungscode gesendet."
            },
            "DISABLE_SYSTEM_EMAIL": {
                "DISABLE_CUSTOM_SERVICE_EMAIL": "Benutzerdefinierte Service-Email deaktivieren",
                "SYSTEM_EMAILS_SEND": "System-Emails werden von der standardmäßigen VSight-Service-Email gesendet.",
                "CANCEL": "Abbrechen",
                "DISABLE": "Deaktivieren"
            },
            "ALWAYS_ARCHIVE": {
                "AUTO_RECORD": "Automatisch alle Arbeitsgruppen aufzeichnen",
                "CHANGE_INDIVIDUALLY": "Aufzeichnungseinstellungen der einzelnen Arbeitsgruppen individuell ändern",
                "AUTO_MESSAGE": "Sessions in allen Arbeitsgruppen werden automatisch aufgezeichnet.",
                "INDIVIDUAL_MESSAGE": "Sie können die Aufzeichnungseinstellungen in den Einstellungen der einzelnen Arbeitsgruppen ändern.",
                "WARNING": "Änderungen an den Einstellungen zur automatischen Aufzeichnung von Videoanrufen werden auf nachfolgende Sitzungen angewendet.",
                "CAUTION": "ACHTUNG: Es besteht eine Peer-to-Peer Arbeitsgruppe. In diesen Arbeitsgruppen ist eine Aufzeichnung nicht möglich.",
                "CANCEL": "Abbrechen",
                "PROCEED": "Fortfahren",
                "CHANGE": "Individuell ändern"
            },
            "WHAT_IS_P2P": {
                "TITLE": "Was bedeutet Peer-to-Peer",
                "BETWEEN_CLIENTS": "Der Audio-Video Stream wird direkt zwischen den Clients aufgebaut.",
                "REDUCED_LATENCY": "Die Peer-to-Peer Option ermöglicht die Reduktion von Latenzen.",
                "ARCHIVE_UNAVAILABLE": "Peer-to-Peer Sessions können nicht aufgezeichnet werden, da eine direkte Verbindung zwischen den beteiligten Peers hergestellt wird.",
                "CLOSE": "Schließen"
            },
            "ADD_EMAIL": {
                "TITLE": "Email erforderlich",
                "ADMIN": "Die Email-Adressen aller Admins und Co-Admins aus dem Usermenü werden benötigt.",
                "ALL": "Alle Email-Adressen aus dem Usermenü werden benötigt.",
                "GO_TO_PROFILE": "Zum Profil gehen",
                "USER_MAILS": "Bitte fügen Sie die Email-Adressen folgender User hinzu:",
                "CLOSE": "Schließen"
            },
            "TWO_FACTOR_MODAL": {
                "ENABLE_ADMIN": "Die Zwei-Faktor-Authentifizierung des Admins aktivieren",
                "DISABLE_ADMIN": "Die Zwei-Faktor-Authentifizierung des Admins deaktivieren",
                "ENABLE_ALL": "Die Zwei-Faktor-Authentifizierung aller User aktivieren",
                "DISABLE_ALL": "Die Zwei-Faktor-Authentifizierung aller User deaktivieren",
                "VERIFICATION_SENDED": "Wir haben Ihnen eine E-Mail mit einem Verifizierungscode gesendet.",
                "VERIFICATION_CODE": "Verifizierungscode",
                "CANCEL": "Abbrechen",
                "SEND_CODE": "Code senden",
                "PROCEED": "Fortfahren"
            },
            "WHITELABEL_SETTINGS": {
                "TITLE": "Whitelabel Einstellungen",
                "SYSTEM_EMAIL_TITLE": "System-Email bearbeiten",
                "SYSTEM_EMAIL_MESSAGE": "Hier können Sie Ihre Service-Email konfigurieren.",
                "ENABLE": "Aktivieren",
                "DISABLE": "Deaktivieren"
            },
            "WEBHOOKS": {
                "TITLE": "Webhooks",
                "NEW_WEBHOOK": "Webhook hinzufügen",
                "NO_WEBHOOK": "Es wurden keine Webhooks gefunden",
                "EVENT": "Ereignis",
                "URL": "URL",
                "SAVE": "Speichern",
                "REMOVE": "Entfernen",
                "ERROR": "Ein Fehler ist aufgetreten.",
                "API_ERROR": "Die Testbenachrichtigung ist fehlgeschlagen.",
                "ADD_WEBHOOK_MODAL": {
                    "TITLE": "Webhook hinzufügen",
                    "PLACEHOLDER": "https://",
                    "WARNING": "Beim Hinzufügen eines neuen Webhooks wird eine Testbenachrichtigung gesendet.",
                    "CANCEL": "Abbrechen",
                    "ADD": "Hinzufügen",
                    "AUTH": "Auth",
                    "KEY": "Key",
                    "VALUE": "Value",
                    "NONE": "Keine",
                    "TOKEN_BASED_BODY": "Token basierend (auf Anfrage-Body)",
                    "TOKEN_BASED_HEADER": "Token basierend (auf Header)",
                    "KEY_PLACEHOLDER1": "z.B. token",
                    "VALUE_PLACEHOLDER1": "z.B. eyJhbGci...",
                    "KEY_PLACEHOLDER2": "z.B. Authorization",
                    "VALUE_PLACEHOLDER2": "z.B. Bearer eyJhbGci...",
                    "EXAMPLE_NOTIFICATION": "Beispielbenachrichtigung",
                    "SHOW_EXAMPLE": "Beispielbenachrichtigung anzeigen",
                    "FORM_WARNING": "Bitte füllen Sie alle Felder aus"
                },
                "REMOVE_WEBHOOK_MODAL": {
                    "TITLE": "Remove Webhook?",
                    "MESSAGE": "Are you sure you want to remove webhook?",
                    "CANCEL": "Abbrechen",
                    "REMOVE": "Entfernen"
                }
            },
            "TICKET_TYPES": {
                "TITLE": "Ticket-Typen",
                "NEW_TYPE": "Ticket-Typ hinzufügen",
                "NO_TYPE": "Keine Ticket-Typen definiert",
                "LOADING": "Ticket-Typen werden geladen...",
                "ID": "ID",
                "NAME": "Name",
                "NAME_PLACEHOLDER": "Ticket-Typ-Namen eingeben",
                "REMOVE": "Entfernen",
                "SAVE": "Änderungen speichern",
                "SAVING": "Wird gespeichert...",
                "ERROR_LOADING": "Ticket-Typen konnten nicht geladen werden",
                "ERROR_SAVING": "Ticket-Typen konnten nicht gespeichert werden",
                "SUCCESS": "Ticket-Typen erfolgreich gespeichert",
                "VALIDATION_ERROR": "Bitte geben Sie für alle Ticket-Typen einen Namen ein",
                "DUPLICATE_ID_ERROR": "Identische Ticket-Typ-Namen erzeugen gleiche IDs. Bitte verwenden Sie eindeutige Namen.",
                "REMOVE_CONFIRM": "Möchten Sie diesen Ticket-Typ wirklich entfernen?",
                "REMOVE_TITLE": "Ticket-Typ entfernen"
            },
            "PASSWORD_POLICY": {
                "TITLE": "Passwort-Richtlinien",
                "SPECIFY_RULE": "Definieren Sie hier die Passwort-Regeln für Ihre User",
                "MIN_LENGTH": "Mindestlänge des Passworts",
                "FOLLOWING_CRITERIAS": "Folgende Kriterien sind zu erfüllen",
                "SAVE": "SPEICHERN",
                "SUCCESS": "Ihre Passwort-Einstellungen wurden geändert.",
                "UPPERCASE": "Großbuchstaben",
                "LOWERCASE": "Kleinbuchstaben",
                "NUMBER": "Zahl",
                "SPECIAL": "Sonderzeichen",
                "ERROR": "Es ist ein Fehler aufgetreten"
            },
            "CONTACT_INFO": {
                "TITLE": "Kontaktinformation",
                "NEW": "Neuer Kontakt",
                "CONTACT": "Kontakt",
                "DEPARTMENT": "Abteilung",
                "NAME": "Name",
                "EMAIL": "Email",
                "PHONE": "Telefonnummer",
                "DELETE": "Löschen",
                "EDIT": "Bearbeiten",
                "CANCEL": "Abbrechen",
                "REVERT": "Umkehren",
                "DEP_REQ": "Abteilung erforderlich",
                "NAME_REQ": "Name erforderlich",
                "EMAIL_REQ": "Email erforderlich",
                "INVALID_EMAIL": "Ungültige E-Mail",
                "SAVE": "SPEICHERN",
                "SUCCESS": "Kontaktinformationen wurden erfolgreich aktualisiert.",
                "FAILED": "Die Aktualisierung der Kontaktdaten ist fehlgeschlagen."
            },
            "SYS_REQ": {
                "TITLE": "Hardware- und Softwareanforderungen",
                "ANDROID_TITLE": "Anforderungen für Android-Geräte",
                "IOS_TITLE": "Anforderungen für iOS-Geräte",
                "NETWORK_TITLE": "Netzwerkanforderungen",
                "BROWSERS_TITLE": "Unterstützte Browser",
                "ANDROID_VERSION": "Android 5.0, oder höher",
                "ANDROID_RAM": "1,5 GB RAM, oder höher",
                "ANDROID_CORE_SPEED": "Maximale Kerngeschwindigkeit 1,5 GHz, oder höher",
                "ANDROID_ARCORE": "Um AR+ verwenden zu können, muss Ihr Gerät ARCore unterstützen. Geräte, die ARCore unterstützen, finden Sie auf dieser Seite: ",
                "ANDROID_ARCORE_DEVICE": "ARCore-unterstützte Geräte",
                "IOS_VERSION": "iOS 13, oder höher",
                "IOS_IPHONE": "iPhone 8, oder neuer",
                "IOS_IPAD": "iPad Pro 2017, oder neuer",
                "IOS_ARKIT": "Um AR+ verwenden zu können, muss Ihr Gerät ARkit unterstützen. Geräte, die ARkit unterstützen, finden Sie auf dieser Seite: ",
                "IOS_ARKIT_DEVICE": "ARkit-unterstützte Geräte",
                "NETWORK_BODY": "Um eine stabile Videoverbindung aufrechtzuerhalten ist eine Internetverbindung mit mindestens 350 Kbit/s Download- und Upload-Geschwindigkeit erforderlich. Für eine optimale Nutzung empfehlen wir allerdings 1 Mbit/ Download- und Upload-Geschwindigkeit mit geringer Latenz.",
                "CHROME": "Google Chrome",
                "FIREFOX": "Mozilla Firefox",
                "SAFARI": "Safari (12, oder höher)",
                "EDGE": "Microsoft Edge (79, oder höher)"
            }
        },
        "STORAGE": {
            "TITLE": "Speicherplatz für Videoanrufaufzeichnungen",
            "REMOTE_ASSISTANCE_STORAGE": "Remote-Assistenz-Speicher",
            "CONNECT_AZURE": "Mit Azure verbinden",
            "DISCONNECT_AZURE": "Verbindung mit Azure trennen",
            "SHARED_DEDICATED_SIZE": "Sie haben <strong>{{dedicated}}</strong>GB Cloud Speicherplatz.",
            "SHARED_DEDICATED_DELETE": "Sobald Ihr Speicher voll ist, werden alte Videoanrufaufzeichnungen gelöscht",
            "SHARED_EXPIRE_TIME": "Ihre Videoanrufaufzeichnungen werden <strong>{{expire}}</strong> Tage lang gespeichert",
            "SHARED_EXPIRE_DELETE": "Nach Ablauf dieser Frist werden die Aufzeichnungen von Videoanrufen gelöscht",
            "SHARED_UNLIMITED": "Sie verfügen über unbegrenzten Speicherplatz mit unbegrenzter Kapazität und unbegrenzter Laufzeit.",
            "PRIVATE_STORAGE_MESSAGE": "Sie können den Azure Cloud-Speicher mit {{appName}} verbinden.",
            "PRIVATE_STORAGE_EXPLANATION": "Aufzeichnungen von Videoanrufen werden in Ihren Cloud-Speicher hochgeladen.",
            "PRIVATE_NO_AZURE": "ES BESTEHT KEINE VERBINDUNG ZUM AZURE CLOUD-SPEICHER.",
            "PRIVATE_AZURE": "ES BESTEHT EINE VERBINDUNG ZUM AZURE CLOUD-SPEICHER.",
            "PRIVATE_AZURE_NAME": "Accountname: {{account_name}}",
            "AZURE_INFO_LOADING": "Wird geladen",
            "CHECK_AZURE_TEMPLATE": {
                "CONNECT_AZURE_CLOUD_STORAGE": "Mit Azure Cloud-Speicher verbinden",
                "DISCONNECT_AZURE_CLOUD_STORAGE": "Verbindung mit Azure Cloud-Speicher trennen",
                "CAUTION": "ACHTUNG: Die Aufzeichnung eines Videoanrufes wird gerade gespeichert. Wenn Sie den Speicher jetzt wechseln, kann dies zum Verlust von Datensätzen führen.",
                "CANCEL": "Abbrechen",
                "CONNECT_ANYWAY": "Trotzdem verbinden",
                "DISCONNECT_ANYWAY": "Trotzdem trennen"
            },
            "CONNECT_AZURE_TEMPLATE": {
                "CONNECT_AZURE_CLOUD_STORAGE": "Mit Azure Cloud-Speicher verbinden",
                "ACCOUNT_NAME": "Accountname",
                "ACCOUNT_NAME_IS_REQUIRED": "Accountname erforderlich",
                "CONTAINER_NAME": "Containername",
                "CONTAINER_NAME_IS_REQUIRED": "Containername erforderlich",
                "ACCOUNT_KEY": "Account Key",
                "ACCOUNT_KEY_IS_REQUIRED": "Account Key erforderlich",
                "CANCEL": "Abbrechen",
                "CONNECT": "Verbinden"
            },
            "DISCONNECT_AZURE_MODAL": {
                "TITLE": "Verbindung mit Azure Cloud-Speicher trennen",
                "MESSAGE": "Die Verbindung mit Ihrem Azure Account wird getrennt.",
                "CAUTION": "ACHTUNG: Wenn Sie die Verbindung zu diesem Account trennen, können Sie die Aufzeichnungen nicht mehr herunterladen, die über das {{appName}} Admin Panel in diesem Account gespeichert wurden.",
                "CANCEL": "Abbrechen",
                "DISCONNECT": "Trennen"
            },
            "ARCHIVE_STORAGE": {
                "ARCHIVE_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Videoanruf aufzeichnen' nicht.",
                "PRIVATE_STORAGE_UNAVAILABLE": "Ihre Lizenz enthält die Funktion 'Azure Integration' nicht."
            },
            "WEBDAV_MESSAGE": "Aufzeichnungen von Videoanrufen werden in Ihr Webdav Konto hochgeladen.",
            "MESSAGES": {
                "AZURE_CONNECTED": "Azure Cloud-Speicher verbunden.",
                "AZURE_DISCONNECTED": "Azure Cloud-Speicher getrennt.",
                "CANNOT_CONNECT": "Azure Cloud-Speicher kann nicht verbunden werden.",
                "CANNOT_DISCONNECT": "Azure Cloud-Speicher kann nicht getrennt werden."
            }
        },
        "ROOM": {
            "SIDEBAR" : {
                "CHAT_TITLE" : "Chat",
                "PARTICIPANTS_TITLE" : "Teilnehmer",
                "FILES_TITLE" : "Dateien",
                "SETTINGS_TITLE" : "Einstellungen",
                "SHOW_TICKET": "Ticket anzeigen",
                "ATTACH_TO_TICKET": "Mit Ticket verknüpfen",
                "ATTACH_SESSION_TO_TICKET": "Session an Ticket anhängen",
                "OPEN_WORKFLOW": "Workflow öffnen",
                "CHAT" : {
                    "SEE_TRANSLATION": "Übersetzung anzeigen",
                    "SEE_ORIGINAL": "Original anzeigen",
                    "TRANSLATING": "Übersetzen",
                    "FILE_SHARE" : {
                        "DRAG_HERE" : "Fügen Sie Dateien per Drag-and-Drop hier ein",
                        "UPLOAD_TITLE": "Daten hochladen",
                        "IMAGE": "Bild",
                        "PDF": "PDF",
                        "3D_OBJECT": "3D Objekt",
                        "OTHER": "Andere",
                        "MULTIPLE_OBJECTS": "Wir haben mehr als ein Objekt in Ihren Dateien gefunden. Bitte laden Sie jeweils nur ein Objekt (mit Texturen, falls vorhanden) hoch.",
                        "LARGER_THAN": "Größer als {{ megabytes }} MB",
                        "FILETYPE_PROHIBITED": "Dateityp unzulässig",
                        "START_UPLOAD": "HOCHLADEN",
                        "CANCEL_UPLOAD": "STOPPEN",
                        "CLOSE_UPLOAD": "SCHLIESSEN",
                        "CANCEL_MODAL_TITLE": "Uploads stoppen?",
                        "CANCEL_MODAL_MESSAGE": "Dadurch werden die aktuellen Uploads gestoppt",
                        "CANCEL_MODAL_CLOSE": "Abbrechen",
                        "CANCEL_MODAL_CANCEL": "Uploads stoppen"
                    },
                    "DELETE_FILE_MODAL": {
                        "TITLE": "Datei löschen?",
                        "MESSAGE": "Die Datei wird gelöscht",
                        "CLOSE": "Schließen",
                        "DELETE": "Löschen"
                    },
                    "FILE_DETAILS_MODAL": {
                        "TITLE": "Dateidetails",
                        "FILENAME": "Dateiname",
                        "SIZE": "Größe",
                        "TYPE": "Typ",
                        "UPLOAD_TIME": "Upload Zeit",
                        "DOWNLOAD": "Download",
                        "CLOSE": "Schließen",
                        "FILECOUNT": "Gesamtanzahl der Dateien"
                    },
                    "COLLABORATE": "Zusammenarbeiten",
                    "CLOSE_COLLABORATION": "Zusammenarbeit schließen",
                    "DOWNLOAD": "Download",
                    "DELETE": "Löschen",
                    "DETAILS": "Details",
                    "SEND_TO_FILES": "Senden an Dateien",
                    "FILE_DELETED": "Datei gelöscht",
                    "JOIN_ROOM" : "{{ owner_info }} ist der Session beigetreten",
                    "LEAVE_ROOM" : "{{ owner_info }} hat die Session verlassen",
                    "REACTION": "{{ owner_info }} hat eine Reaktion gesendet",
                    "REQUEST_SCREENSHOT": "{{ owner_info }} hat einen Schnappschuss erstellt",
                    "SHARE_SCREENSHOT" : "{{ owner_info }} hat eine Schnappschuss geteilt",
                    "SAVED_COLLABORATION": "Zusammenarbeit gespeichert",
                    "SHARE_IMAGE" : "{{ owner_info }} hat ein Bild geteilt",
                    "SHARE_PDF" : "{{ owner_info }} hat ein PDF geteilt",
                    "SHARE_OTHER" : "{{ owner_info }} hat eine Datei geteilt",
                    "SHARE_OBJECT" : "{{ owner_info }} hat ein 3D-Objekt geteilt",
                    "COLLABORATED" : "{{ owner_info }} hat die Zusammenarbeit begonnen",
                    "TYPE_HERE" : "hier eingeben...",
                    "PLEASE_WAIT_OTHERS": "Bitte warten Sie, bis andere User beitreten.",
                    "DOWNLOAD_STARTED_SOON": "Der Download wird in Kürze gestartet.",
                    "DOWNLOAD_FAILED": "Download fehlgeschlagen",
                    "DOWNLOAD_OBJECT_NOT_SUPPORTED": "Der Download dieses Objektformats wird noch nicht unterstützt.",
                    "DOWNLOAD_NOT_SUPPORTED": "Dieser Download wird noch nicht unterstützt.",
                    "CLOSE_PREV_COLLABORATION_TITLE": "Aktuelle Zusammenarbeit an der Datei schließen?",
                    "CLOSE_COLLABORATION_TITLE": "Zusammenarbeit an der Datei schließen?",
                    "CLOSE_PREV_COLLABORATION_MESSAGE": "Dadurch wird die aktuelle Zusammenarbeit an der Datei geschlossen und eine neue gestartet.",
                    "CLOSE_COLLABORATION_MESSAGE": "Dadurch wird die Zusammenarbeit an der Datei geschlossen und Sie gelangen zurück zum Video-Stream.",
                    "CLOSE_PREV_COLLABORATION_YES": "Zusammenarbeit schließen",
                    "CLOSE_PREV_COLLABORATION_NO": "Abbrechen",
                    "DISABLE_FOCUS_MODAL": {
                        "TITLE": "Datei-Zusammenarbeit starten?",
                        "MESSAGE_AUTHORIZED": "Ein Fenster ist angeheftet. Möchten Sie es lösen und die Datei-Zusammenarbeit starten?",
                        "MESSAGE_UNAUTHORIZED": "Die Datei-Zusammenarbeit kann nicht gestartet werden, da ein Fenster angeheftet ist.",
                        "CANCEL": "Abbrechen",
                        "CLOSE": "Schließen",
                        "PROCEED": "Fortfahren"
                    },
                    "CLOSE_ARPLUS_BEFORE_COLL": {
                        "TITLE": "AR+ schließen?",
                        "MESSAGE": "Sie müssen AR+ schließen, um die Zusammenarbeit an einer Datei zu starten. Sind Sie sicher, dass Sie den AR+ Modus beenden möchten?",
                        "NO": "Nein",
                        "YES": "Ja"
                    }
                },
                "PARTICIPANTS": {
                    "HOST": "(Host)",
                    "LOWER_ALL_HANDS": "Alle Meldungen ablehnen",
                    "RAISED_HAND": "{{ name }} meldet sich per Handzeichen.",
                    "DENIED_PUBLISH": "{{ name }} hat die Audio-Video Übertragung abgelehnt",
                    "PARTICIPANT_LIMIT_REACHED": "Teilnehmerlimit für die Session erreicht",
                    "CALLING": "Anruf an: {{ participants }}"
                },
                "FILES": {
                    "INFO_TEXT": "Alle Experten und Co-Admins, die Zugriff auf diese Arbeitsgruppe haben, können die Dateien in diesem Abschnitt sehen und ändern",
                    "DOWNLOAD": "Download",
                    "SEND_TO_SESSION": "An Session senden",
                    "DELETE": "Löschen",
                    "UPLOAD_FILE": "Datei hochladen",
                    "FILE_CONTENTS": "Dateiinhalt:",
                    "FILE_NAME": "Dateiname:",
                    "FILE_SIZE": "Dateigröße:",
                    "TOTAL_SIZE": "Gesamtgröße:",
                    "DOWNLOAD_STARTED_SOON": "Der Download wird in Kürze gestartet.",
                    "DOWNLOAD_FAILED": "Download fehlgeschlagen",
                    "DELETE_MODAL": {
                        "TITLE_DELETE": "Datei löschen?",
                        "MESSAGE_DELETE": "Möchten Sie diese Datei wirklich löschen?",
                        "CANCEL": "Abbrechen",
                        "DELETE": "Löschen"
                    }
                },
                "SETTINGS": {
                    "MICROPHONE": "Mikrofon",
                    "CAMERA": "Kamera",
                    "TRANSLATE_OTHERS_MSG_TO": "Andere Nachrichten übersetzen in:",
                    "TRANSLATE_MY_MSG_TO": "Meine Nachrichten übersetzen in:",
                    "CREATE_GUEST_ACCESS": "Gastzugang erstellen",
                    "GENERATING": "Erstellen",
                    "GUEST_ACCESS": "Gastzugang",
                    "COPY_LINK": "Kopieren",
                    "LINK_COPIED": "Der Link wurde in die Zwischenablage kopiert.",
                    "LINK_GENERATED": "Der Gastzugangslink wurde generiert.",
                    "CANNOT_CREATE_GUEST_ACCESS": "Der Gastzugang konnte nicht erstellt werden.",
                    "NO_LINK_PERMISSION": "Sie sind nicht berechtigt, einen Gastzugangslink zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
                    "SHARE": "Teilen",
                    "SHARE_LINK_VIA_SMS": "Link per SMS teilen",
                    "SMS_SEND": "Der Link wurde per SMS gesendet.",
                    "OPENING": "Wird geöffnet",
                    "SEND": "Senden",
                    "SMS_LIMIT_REACHED": "SMS-Limit erreicht. Bitte kontaktieren Sie Ihren Administrator.",
                    "ERROR_OCCURED": "Es ist ein Fehler aufgetreten.",
                    "SMS_LICENSE_PERMISSION": "Sie haben keine Berechtigung SMS zu versenden. Bitte kontaktieren Sie Ihren Administrator.",
                    "RESHARE": "Das Teilen dieses Links ist einmal pro Minute möglich.",
                    "DIDNT_GET": "Link nicht erhalten?",
                    "PHONE_NUMBERS": "Kürzlich verwendete Telefonnummern",
                    "RESEND": "Erneut senden",
                    "CANCEL": "Abbrechen",
                    "CONNECT_VIA_FIELD_CODE": "Über einen Field ID mit dem User verbinden",
                    "CONNECT": "Verbinden",
                    "INVITATION_SENT": "Die Einladung wurde an den User gesendet.",
                    "INVITATION_COULD_NOT_SENT": "Beim Senden der Einladung an den User ist ein Fehler aufgetreten.",
                    "FIELD_CODE": "Field ID"
                }
            }
        },
        "LICENSE_MODAL": {
            "TITLE": "Kontoübersicht",
            "LOADING": "Wird geladen",
            "START": "Startdatum",
            "END": "Enddatum",
            "TYPE": "Lizenztyp",
            "CONCURRENT_LIMIT_ACCOUNT": "In Ihrem Konto wurde das Limit für gleichzeitig angemeldete User erreicht",
            "CONCURRENT_LIMIT_ROOM": "In Ihrer Arbeitsgruppe wurde das Limit für gleichzeitig angemeldete User erreicht",
            "EXPERT_LIMIT": "Max. Experten",
            "CON_EXPERT_LIMIT": "In Ihrem Konto wurde das Limit für gleichzeitig angemeldete Experten erreicht",
            "UNLIMITED": "Unbegrenzt",
            "LIMIT_VALUE": "{{ limit }}",
            "LIMIT2_VALUE": "{{ limit2 }}",
            "EXP_CON_LIMIT_VALUE": "{{ expert_concurrent_limit }}",
            "ROOM_LIMIT_VALUE": "{{ room_limit }}",
            "ARCHIVE": "Aufzeichnung von Videoanrufen",
            "ARCHIVE_AVAILABLE": "Verfügbar",
            "ARCHIVE_UNAVAILABLE": "Nicht verfügbar",
            "CLOSE": "Schließen",
            "EXPERT_USER_BASED": "Experten-basiert",
            "ROOM_LIMIT": "Limit der zu erstellenden Arbeitsgruppen",
            "CONCURRENT_USER_BASED": "Basierend auf gleichzeitigen Benutzern",
            "LIMIT": "Maximale User pro Session",
            "WORKFLOW_USER_LIMIT": "Benutzerlimit",
            "LIMIT2": "Maximal erstellbare Experten",
            "EXPERT_CONCURRENT_LIMIT": "Maximal gleichzeitig eingeloggte Experten",
            "ALLOW_ARCHIVING": "Aufzeichnung von Sessions",
            "TRAININGLICENSES": "Schulungsraum Lizenz",
            "CONSUMED": "Bereits genutzt",
            "LICENCE_HOURS": "{{hours}} Stunden Packet"
        },
        "LICENCE-EXPIRED": "Deine Lizenz ist abgelaufen"
    },
    "MODALS": {
        "JOIN_MODAL": {
            "JOIN" : "BEITRETEN",
            "CALL": "ANRUF",
            "CANCEL": "ABBRECHEN",
            "MIRROR_VIDEO": "Video spiegeln",
            "PREFERRED_RESOLUTION": "Bevorzugte Auflösung",
            "RESOLUTION_NOTE": "Anmerkung: Sofern Ihr Gerät die gewünschte Auflösung nicht unterstützt, wird die nächst-größere verwendet.",
            "CAM_MIC_PERM_REQUIRED": "Freigabe von Kamera und Mikrofon erforderlich",
            "CAM_MIC_PERM_DENIED": "Zugriff auf Kamera oder Mikrofon verweigert",
            "CAM_MIC_CANT_ACCESS": "Wir können nicht auf Ihre Kamera und Ihr Mikrofon zugreifen.",
            "JOIN_CAM_OFF": "Mit ausgeschalteter Kamera beitreten",
            "JOIN_MIC_OFF": "Mit ausgeschaltetem Mikrofon beitreten",
            "JOIN_CAM_MIC_OFF": "Mit ausgeschalteter Kamera und ausgeschaltetem Mikrofon beitreten",
            "JOIN_NO_DEVICE": "Trotz nicht vorhandenem Mikrofon/Kamera teilnehmen",
            "ALLOW_ACCESS": "Bitte erteilen Sie in den Browsereinstellungen den Zugriff auf Ihre Kamera und Ihr Mikrofon (Danach können Sie der Session trotzdem ohne Kamera und Mikrofon beitreten).",
            "TRY_AGAIN": "Bitte erneut versuchen / Aktualisieren Sie diese Seite und wählen Sie 'Erlauben', wenn der Browser Sie darum bittet."
        },
        "GET_EXPORT_MODAL": {
            "TITLE": "Sessionexport abrufen",
            "MESSAGE1": "Bitte geben Sie Ihre Email-Adresse ein, um nach Beendigung der Session den Download-Link für den Sessionexport zu erhalten.",
            "MESSAGE2": "Der Sessionexport umfasst alle Chat-Nachrichten, Schnappschüsse, Videoanrufaufzeichnungen und Dateien, die in der Session freigegeben wurden.",
            "EXPORT_NAME_NOT_LOCKED": "Sie können die Exportdatei umbenennen, indem Sie stattdessen einen benutzerdefinierten Dateinamen eingeben.",
            "EXPORT_NAME_LOCKED": "Sie können die Exportdatei umbenennen, sobald der andere Benutzer den Export abgeschlossen hat.",
            "EXPORT_NAME_RENAMED": "Exportdatei wird von diesem Benutzer umbenannt:",
            "EXPORT_NAME_PLACEHOLDER": "Exportname",
            "NOTE": "Hinweis: Sie können Ihre Email-Adresse über das Profilmenü aktualisieren.",
            "OPEN_PROFILE": "Profil bearbeiten",
            "EMAIL": "Email",
            "CLOSE": "Schließen",
            "SEND": "Senden",
            "EXPORT_SUCCEEDED": "Der Session-Export wird nach Beendigung der Session gesendet.",
            "ENDED_SESSION_EXPORT_SUCCEEDED": "Der Session-Export wird gesendet.",
            "EXPORT_FAILED": "Es ist ein Fehler aufgetreten."
        },
        "ALERT": {
            "TEXT": "Sind Sie sicher?",
            "CANCEL": "Abbrechen",
            "CONFIRM": "Löschen",
            "CONTINUE": "Fortfahren"
        },
        "IMAGE-EDITOR": {
            "TITLE": "Bildbearbeitung",
            "CANCEL": "Abbrechen",
            "SAVE": "Speichern",
            "CROP": "Zuschneiden"
        },
        "TEMPLATE": {
            "CREATE-STEP": "Schritt erstellen",
            "OPTIONS": {
                "TITLE": "Wählen Sie ein Layout",
                "FULL": "ganze Seite",
                "VERTICAL": "vertikale Teilung",
                "HORIZONTAL": "horizontale Teilung "
            },
            "CREATE": "Erstellen",
            "CHANGE": "Ändern"
        },
        "WORKFLOW-USERS": {
            "TITLE": "Workflow-User",
            "USERS": "User",
            "SELECTED": "Ausgewählte User",
            "CLOSE": "Schließen",
            "SAVE": "Speichern",
            "LIMIT-FULL": "Das Workflow-Benutzerlimit ist voll"
        },
        "WORKFLOW-SHARING": {
            "TITLE": "Workflow mit Unterkonten teilen",
            "DESCRIPTION": "Wählen Sie aus, welche Unterkonten auf diesen Workflow zugreifen können.",
            "NOT_PARENT_ACCOUNT": "Dieses Konto ist kein übergeordnetes Konto oder hat keine Unterkonten.",
            "NO_CHILDREN": "Keine verknüpften Unterkonten.",
            "CLOSE": "Schließen",
            "SAVE": "Freigabeeinstellungen speichern",
            "SHARING_UPDATED": "Freigabeeinstellungen erfolgreich aktualisiert",
            "SHARING_ERROR": "Freigabeeinstellungen konnten nicht aktualisiert werden"
        },
        "GENERATE-WORKFLOW": {
            "TITLE": "Automatischen Workflow Mit KI Erstellen",
            "PROMPT-TEXT": "Erstellen Sie sofort einen Workflow, indem Sie unten eine Textbeschreibung eingeben. Unser KI-Tool generiert automatisch einen schrittweisen Workflow mit allen notwendigen Inhalten.",
            "CONFIRM-BUTTON-TEXT": "EINREICHEN",
            "CANCEL-BUTTON-TEXT": "STORNIEREN",
            "INVALID-WORKFLOW-ERROR" : "Workflow kann nicht mit Eingabeaufforderung erstellt werden",
            "PERMISSION-DENIED": "Sie haben keine Berechtigung",
            "PROMPT-REQUIRED": "Eingabeaufforderung nicht gefunden",
            "INTERNAL-ERROR": "Ein Fehler ist aufgetreten"
        },
        "SIGNATURE": {
            "ADD-SIGNATURE": "Signatur hinzufügen",
            "DRAW-SIGNATURE": "Zeichnen Sie Ihre Unterschrift",
            "CLEAR": "Löschen",
            "REQUIRED-NAME": "Name ist erforderlich",
            "INSERT": "Einfügen",
            "TYPE-SIGNATURE": "Geben Sie Ihre Signatur ein",
            "USE-PHOTO": "Verwenden Sie ein Foto Ihrer Unterschrift",
            "FULL-NAME": "Vollständiger Name"
        },
        "WORKFLOW-NEW-LANGUAGE": {
            "ADD-LANGUAGE": "Sprache hinzufügen",   
            "NEW-LANGUAGE": "Sie sind dabei, dem Workflow eine neue Sprache hinzuzufügen. Möchten Sie alle Inhalte automatisch von der Standardsprache in die Sprache übersetzen, die Sie hinzufügen? Wenn Sie den Inhalt selbst übersetzen möchten, können Sie alle Standardinhalte in die neue Sprache kopieren und manuell bearbeiten.",
            "AUTO-TRANSLATE": "Automatisch übersetzen",
            "COPY-CONTENT": "Inhalte aus der Standardeinstellung kopieren"       
        },
        "DEFAULT-LANGUAGE": {
            "PRIMARY-LANGUAGE": "Die Sprache, die Sie als Standard auswählen, ist die primäre Sprache, in der Benutzer diesen Workflow auf ihren Geräten anzeigen. Sie können einen mehrsprachigen Workflow erstellen, indem Sie im Editor zusätzliche Sprachen hinzufügen, nachdem Sie den Workflow erstellt haben.",
            "DEFAULT-LANGUAGE": "Standardsprache dieses Workflows",
            "CREATE": "ERSTELLEN"
        },
        "USER-DEFAULT-LANGUAGE": {
            "PREFFERED-LANGUAGE": "Wählen Sie die bevorzugte Sprache aus, in der Sie den Workflow-Inhalt anzeigen möchten."
        },
        "TABLE-CELL": {
            "AT-LEAST": "Dieses Feld sollte mindestens {{min}} groß sein.",
            "AT-MOST": "Dieses Feld sollte höchstens {{max}} sein"
        },
        "OPEN-AI": {
            "DESCRIBE": "Beschreiben Sie den Workflow, den Sie erstellen möchten"
        }
    },
    "EXTERNALS": {
        "AD_LOGIN": {
            "MESSAGE": "Es ist ein Fehler aufgetreten."
        },
        "AD_ERROR": {
            "ACCOUNT_NOT_FOUND": "Ihr Konto ist nicht mit Azure AD verbunden.",
            "PERMISSION_DENIED": "Sie sind nicht berechtigt, diese Seite anzuzeigen.",
            "INTERNAL_ERROR": "Es ist ein Fehler aufgetreten.",
            "CONTACT_MAIL": "Bitte kontaktieren Sie <strong>{{ contactMail }}</strong>"
        }
    },
    "NOT-FOUND": {
        "TEXT": "Es tut uns leid, die von Ihnen angeforderte Seite kann nicht gefunden werden.",
        "INFORM": "Möglicherweise ist die URL falsch geschrieben oder die gesuchte Seite ist nicht mehr verfügbar."
    },
    "ERRORS": {
        "UPLOAD-ERROR": "Upload-Fehler",
        "ERROR": "Es ist ein Fehler aufgetreten."
    },
    "WEB-VERSION": {
        "TASK-TO-COMPLETE": "Durchzuführende Schritte",
        "ESTIMATED-DURATION": "Geschätzte Dauer",
        "START": "START",
        "PREVIOUS": "Zurück",
        "NEXT": "Weiter",
        "SUBMIT": "Einreichen",
        "SUCCESS-SUBMIT-MESSAGE": "Ihr Workflow wurde erfolgreich eingereicht!",
        "SUCCESS-SAVE-MESSAGE": "Ihr Workflow wurde erfolgreich gespeichert!",
        "SAVE-AS-DRAFT": "Als Entwurf speichern",
        "CLOSE-WORKFLOW-WARNING-TEXT": "Möchten Sie diesen Workflow wirklich schließen? Ihre Änderungen werden verworfen.",
        "CONTINUE-WORKFLOW-TEXT-MESSAGE": "Sie haben diesen Workflow bereits gestartet. Möchten Sie fortfahren oder neu starten?",
        "CONTINUE": "Fortfahren",
        "START-OVER": "NEU STARTEN",
        "INCOMPLETE": "Unvollständig",
        "SUBMITTED": "Eingereicht",
        "VERSION": "Version",
        "LAST-SAVED": "Zuletzt gespeichert",
        "PUBLISHED-AT": "Veröffentlicht am",
        "STATUS": "Status",
        "SELECT": "Auswählen",
        "SEARCH": "Suchen",
        "SAVE": "Speichern",
        "CANCEL": "Abbrechen",
        "CLEAR": "Leeren"
    },
    "Number": "Nummer",
    "Text": "Text",
    "Multiple Choice": "Multiple Choice",
    "Checkboxes": "Checkboxen",
    "Date": "Datum",
    "Time": "Zeit",
    "File Upload": "Datei-Upload",
    "Capture Image": "Bild aufnehmen",
    "Capture Video": "Video aufnehmen",
    "PPE": "PSA",
    "QR": "QR",
    "Contains": "Enthält",
    "Does not contain": "Enthält nicht",
    "Is empty": "Ist leer",
    "Is not empty": "Ist nicht leer",
    "Equals": "Ist gleich",
    "Not Equals": "Ist nicht gleich",
    "Greater than": "Ist größer als",
    "Less than": "Ist kleiner als",
    "Greater or Equal": "Ist größer-gleich",
    "Less or Equal": "Ist kleiner-gleich",
    "Is": "Ist",
    "Is not": "Ist nicht",
    "Starts with": "Beginnt mit",
    "Ends with": "Endet mit",
    "Is before": "Ist vor",
    "Is after": "Ist nach",
    "Is between": "Ist zwischen",
    "Is not between": "Ist nicht zwischen",
    "Is detected": "Wurde erkannt",
    "Is not detected": "Wurde nicht erkannt",
    "input": "TEXTEINGABE",
    "number": "ZAHLENEINGABE",
    "datepicker": "DATUMSAUSWAHL",
    "multicheckbox": "CHECKBOXEN",
    "radio": "RADIOBUTTONS",
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "Einträge pro Seite:",
        "NEXT_PAGE": "Nächste Seite",
        "PREVIOUS_PAGE": "Vorherige Seite",
        "FIRST_PAGE": "Erste Seite",
        "LAST_PAGE": "Letzte Seite",
        "RANGE": "{{start}} – {{end}} von {{length}}",
        "RANGE_ZERO": "0 von {{length}}"
    }
}